import {  Button, Checkbox, Dialog, IconButton, Menu, MenuItem, TableBody, TableCell } from "@mui/material";
import {  StyledSelectDropdown, StyledTableRowhelper, TicketPlacements, manageticketsrowType, rowsType, getTimeRemaining, CustomPaperComponent, listTicketsRowType,soldTicketsRowType, checking, createdAtFormatDateTime, splitLocationForVenue, EditTicketType, PayoutType, formatUnderScore, roles, VenuesRowType, Venue, formatNumberWithCommas } from "../../../helper";
import styles from './AppTable.module.css'
import { ExpandMore, MoreHoriz } from "@mui/icons-material";
import ActionDropdown from "../dropdown/bulkaction-dropdown/ActionDropdown";
import { useState,useEffect, useContext } from "react";
import {  useLazyQuery, useMutation } from '@apollo/client';
import { ADD_REFERRED_BY, GET_USERS_LIST, SEND_VERIFICATION, UPDATE_USER } from "../../../features/Users/api/UsersQuery";
import { globalContext } from "../../../Provider/AppProvider";
import ToasterWithMessage from "../toaster/index";
import MarkAsSold from "../mark-as-sold/MarkAsSold";
import PublishPopup from "../success-popup/PublishPopup";
import images from "../../../assets/images";
import InvoicePopup from "../invoice/Invoice";
import AddAffiliate from "../add-affiliate/AddAffiliate";
import { affiliateUser, getAffiliates } from "../../../features/Affiliate/Affiliate";
import { DELETE_AFFILIATE, GET_AFFILIATE_BY_ID, GET_AFFILIATE_BY_ID_DIRECT_INDIRECT } from "../../../features/Affiliate/api/AffiliateQuery";
import ReferralUrl from "../referralurl/ReferralUrl";
import {useNavigate} from 'react-router-dom'
import PublishPopupSingle from "../success-popup/PublishPopupSingle";
import {  AUTO_PAYOUT, DELIST_TICKET, FORCE_UPDATE_TICKET, GET_EDIT_TICKET_DETAIL, RETURN_TICKET, PUBLISH_TICKETS, UPDATE_LIST_PRICE, VALIDATE_UPDATE, UPDATE_TP_PAYOUT_STATUS, EDIT_TICKET, UNDO_DELIST_REQUEST_TO_LIST } from "../../../features/Tickets/api/TicketsQuery";
import { GET_BONUS_AMOUNTS, GET_SUPER_USER_BY_UID } from "../../../features/PriceSetUp/api/PriceSetUp";
import EditPricePopUp from "../success-popup/EditPricePopUp";
import { TRIGGER_ERROR_TICKETS } from "../../../features/ErrorDashboard/api/ErrorQuery";
import EditTicketPopUp from "../success-popup/EditTicketPopUp";
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import { getAffiliateTransactionsType } from "../../../features/Affiliate/AffiliateTransactions";
import moment from "moment";
import DisplayAffiliate from "../../../features/Affiliate/DisplayAffiliate";
import { DELETE_VENUE_NAME_BY_ID, UPDATE_ACTIVE_OR_INACTIVE_EVENT, UPDATE_LEAGUE_TEAM_VENUE_AVID_BY_ID,DEACTIVATE_SUPER_USER, UPDATE_SUPER_USER_PERCENTAGE,GET_ALL_SUPER_USERS } from "../../../features/AddTickets/api/addTicketsQuery";
import EditVenueModal from "../../../features/VenueUpdate/model/EditVenueModal";
import ConfirmDeleteDialog from "../../../features/VenueUpdate/model/ConfirmDeleteDialog";
import { NumberEditPopup } from "../success-popup/NumberEditPopup";
import { useSuperUsers } from "../../../useSuperUsers";
interface userType{
  emailId: string,
  link: string
}
const StyledTableRow = StyledTableRowhelper();

export function UsersTableBody(props :any){
  const {error,success} = ToasterWithMessage();
    const {list, isSelected,handleClick,hanleclickopenmenu, open, anchorEl,handleClose,setCurrentPage,setColumnTypes,setSortType,setChecking,setSelected, setUsersList} = props;
    const [selectedUser, setSelectedUser] = useState<string[] | []>([]);
    const [isActiveORInactive,setActiveORInactive] = useState<boolean | null>(null);
    const [isDelete,setDelete] = useState<boolean>(false);
    const [isUserActive,setUserActive] = useState<boolean>();
    const [isUserVerified,setUserVerified] = useState<boolean>();
    const [userDetails,setUserDetails] = useState<rowsType>();
    const [sentMail,setSentMail] = useState<boolean>(false);
    const [userToVerify,setUserToVerify] = useState<userType[] | []>([]);
    const [isShowReferPopup, setIsShowReferPopup] = useState<boolean>(false);
    const [userId, setUserId] = useState<string | null>(null);
    const {UserEdit} = images;
    const StyledComponent = CustomPaperComponent();
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
    const [updateUser] = useMutation(UPDATE_USER, {
      fetchPolicy: 'no-cache',
      onCompleted: () => {
        setActiveORInactive(null);
        setCurrentPage(1);
        setColumnTypes("u_updated_at");
        setSortType("desc");
        if(isDelete){
          success("Deleted successfully");
        } else {
          success("Updated successfully");
        } 
        const tempState = {...globalState};
        tempState.userUpdate.updated = true;
        tempState.usersPageLoader.updateLoader = false;
        handleGlobalState(tempState)
        setDelete(false);
        setSelectedUser([]);
      },
      onError: (err)=>{
        setActiveORInactive(null);
        setDelete(false);
        setSelectedUser([]);
        const tempState = {...globalState};
        tempState.userUpdate.updated = false;
        tempState.usersPageLoader.updateLoader = false;
        handleGlobalState(tempState)
        if(err.message.includes("cannot be deleted")){
          error(err.message);
        }else{
          error("Something went wrong!")
        }
      }
    });
  
      useEffect(() => {
        if(selectedUser.length > 0){
          const tempData = {...globalState};
          tempData.usersPageLoader.updateLoader = true;
          handleGlobalState(tempData);
          updateUser({
            variables:{
              userStatusInput: {
                activeInActive: isActiveORInactive,
                deletedAt: isDelete,
                userId: selectedUser
              }
            }
          })
        }
       
    // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [isActiveORInactive,isDelete])

    const [sendVerificationLink] = useMutation(SEND_VERIFICATION,{
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        success("Mail sent successfully")
        setChecking(false);
        setSelected([]);
      },
      onError: (err) => {
        error("Something went wrong!");
        setChecking(false);
        setSelected([]);
      }
    })

    useEffect(() => {
      if(selectedUser.length > 0){
        sendVerificationLink({
          variables: {
            verifyUserInput: userToVerify
          }
        })
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[userToVerify])

    const handleSetUserStatus = (active: boolean, verified: boolean): string[] => {
        if(active && verified){
          return ['Active',styles.statusActive,'-'];
        }else if(active === false && verified === false){
          return ['Invite',styles.statusVerified,'Not verified'];
        }else if (active === false && verified === true){
          return ['Deactive',styles.statusDeactive,`Admin updated`];
        }else {
          return [];
        }
    }

  const [getUsersList] = useLazyQuery(GET_USERS_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setCurrentPage(1);
      setUsersList(data)
    },
    onError: () => {
      error("Error Fetching user data!")
    }
  })


  const [addReferredBy, {loading}] = useMutation(ADD_REFERRED_BY, {
    fetchPolicy: "no-cache",
    onCompleted: async (data) => {
      await getUsersList({variables:{
        pageSize: 10,
        pageOffset: 0,
        order_by: { 'u_updated_at': 'desc'}
      }})
      success("User Referred Successfully!");
      setIsShowReferPopup(false);
    },
    onError: (err) => {
      error(err?.message);
    }
  })

    const handleAllowReferAffiliate = (referredId: string) => {
      addReferredBy({
        variables: {
          userId,
          userReferralId: referredId
        }
      })
    }

    const handleEditUser = (uId: string) => {
      setIsShowReferPopup(true);
      setUserId(uId);
    }

    return (
      <>
        <TableBody className={styles.tablebodyStyle}>
        {list?.user?.map((row: rowsType, index: number) => {
          const isItemSelected = isSelected(index);
          const labelId = `enhanced-table-checkbox-${index}`;

          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{root: styles.rowStyle}}
            >
              {(globalState.profile.userRole === roles.MARKETING_USER || globalState.profile.userRole === roles.AFFILIATER_ADMIN) ? null :<TableCell
                padding="checkbox"
                classes={{
                  root: styles.tablecell,
                }}
                size="small"
              >
                <Checkbox
                  onClick={(event) => handleClick(event,index, row?.u_id)}
                  classes={{
                    colorPrimary: styles.unselectCheckbox,
                    checked: styles.selectedCheckbox,
                  }}
                  disableRipple
                  checked={isItemSelected}
                  inputProps={{
                    "aria-labelledby": labelId,
                  }}
                  data-testid = {`checkbox${index}`}
                />
              </TableCell>}
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.u_full_name}`}</span></TableCell>
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{row?.u_stripe_business_name ? `${row?.u_stripe_business_name}` : '-'}</span></TableCell>
              <TableCell size="small" className={styles.usersEmailCell}>
              <span className={styles.customtableCell}> {row?.u_email_id} </span>
              </TableCell>
              <TableCell size="small" className={styles.usersPhoneNumberCell}><span className={styles.customtableCell}>{`${row?.u_phone_number}`}</span></TableCell>
              <TableCell size="small" className={styles.usersStatusCell}>
                <span
                  className={handleSetUserStatus(row?.u_is_active,row?.u_is_verified)[1]}
                >
                  {handleSetUserStatus(row?.u_is_active,row?.u_is_verified)[0]}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.u_id}`}</span></TableCell>
              <TableCell size="small" className={styles.userStatusReason}><span className={styles.customtableCell}>{handleSetUserStatus(row?.u_is_active,row?.u_is_verified)[2]}</span></TableCell>
              <TableCell size="small" className={styles.userStatusReason}><span className={styles.customtableCell}>{row?.u_delete_requested===true?"Requested":"-"}</span></TableCell>
              <TableCell size="small" className={styles.affiliate}><span className={styles.customtableCell}>{`${row?.user_referred_to ? `${row?.user_referred_to?.user_referred_by?.u_first_name } - ${row?.user_referred_to?.ur_joining_code} `   :'-'}`}</span></TableCell>
              {/* <TableCell size="small" className={styles.numberOfReferrals}>
                <span className={styles.customtableCell}>
                  {(row?.user_referred_by_aggregate?.aggregate?.count === null ||
                    row?.user_referred_by_aggregate?.aggregate?.count === 0) 
                  ? 0 
                  : row?.user_referred_by_aggregate?.aggregate?.count
                  }
                </span>
              </TableCell> */}
              {/* <TableCell size="small" className={styles.earnings}>
                <span className={styles.customtableCell}>
                  {row?.u_total_earnings ? `$ ${row?.u_total_earnings}` : `$ 0`}
                </span>
              </TableCell> */}
              <TableCell size="small" className={styles.activeTickets}><span className={styles.customtableCell}>{(row?.tickets_aggregate?.aggregate?.sum?.t_active_tickets === null || row?.tickets_aggregate?.aggregate?.sum?.t_active_tickets === 0) ? 0 : row?.tickets_aggregate?.aggregate?.sum?.t_active_tickets}</span></TableCell>
              <TableCell size="small" className={styles.soldTickets}><span className={styles.customtableCell}>{(row?.tickets_aggregate?.aggregate?.sum?.t_sold_tickets === null || row?.tickets_aggregate?.aggregate?.sum?.t_sold_tickets === 0) ? 0 : row?.tickets_aggregate?.aggregate?.sum?.t_sold_tickets}</span></TableCell>
              <TableCell size="small" className={styles.soldTickets}><span className={styles.customtableCell}>{row?.tickets_sold_amount ? `$${formatNumberWithCommas(row?.tickets_sold_amount)}` : `$0`}</span></TableCell>
              {globalState.profile.userRole === "marketing_user"? null :<TableCell size="small" className={styles.usersUserNameCell}><span className={styles.stripeId}>{row?.u_stripe_account_id ? row?.u_stripe_account_id : '-'}</span></TableCell>}
              <TableCell size="small" className={styles.usersLoginCell}>
                {
                  row?.u_last_online
                ? 
                  <>
                  <div className={styles.customtableCell}>{`${createdAtFormatDateTime(row?.u_last_online)[0]}`}</div>
                  <div className={styles.customtableCell}>{`${createdAtFormatDateTime(row?.u_last_online)[1]}`}</div>
                  </>
                : <span>{`-`}</span>
                }
              </TableCell>
              <TableCell size="small" className={styles.usersCreatedAtCell}>
                <span className={styles.customtableCell}>{row?.u_created_at ? createdAtFormatDateTime(row?.u_created_at)[0] : '-' }</span>
              </TableCell>
              {(globalState.profile.userRole === roles.MARKETING_USER || globalState.profile.userRole === roles.AFFILIATER_ADMIN) ? null :
                <TableCell
                size="small"
                className={styles.stickyTableCellForUser}
              >
                <div className = {styles.actionContainer}>
                <div className={styles.actionmoreIcon}>
                  <IconButton
                    disableRipple
                    onClick={(e) => {
                      hanleclickopenmenu(e);
                      setUserActive(row?.u_is_active);
                      setUserVerified(row?.u_is_verified)
                      setUserDetails(row);
                      setSelectedUser([row.u_id])
                    }}
                  >
                    <MoreHoriz
                      classes={{
                        root: styles.moreVerIcon,
                      }}
                      data-testid = {`actionmoreicon-${index}`}
                    />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      "aria-labelledby": "long-button",
                      disablePadding: true,
                    }}
                    transformOrigin={{
                      horizontal: "right",
                      vertical: "top",
                    }}
                    anchorOrigin={{
                      horizontal: "right",
                      vertical: "bottom",
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    classes={{
                      root: styles.DropdownMenuItem,
                      paper: styles.actionDropdown,
                    }}
                  >
                    <ActionDropdown
                     isUserActive = {isUserActive}
                     isUserVerified = {isUserVerified}
                     userDetails = {userDetails}
                     setDelete={setDelete}
                     setUserToVerify = {setUserToVerify}
                     setActiveOrInactive = {setActiveORInactive}
                     setSentMail= {setSentMail}
                     handleCloseMenu={handleClose}/>
                  </Menu>
                </div>
                {
                  !row?.user_referred_to && <div className={styles.actionmoreIcon}>
                  <Button classes={{root: styles.editPriceSeparateStyle}} 
                  fullWidth onClick={() => handleEditUser(row.u_id)}>
                    <img src={UserEdit} alt="useredit" />
                  </Button>
                </div>
                }
                </div>
              </TableCell>}
            </StyledTableRow>
          );
        })}
        </TableBody>
        <Dialog
          open={isShowReferPopup}
          PaperComponent={StyledComponent}
        >
          <PublishPopup handleAllow={handleAllowReferAffiliate} handleClose={() => setIsShowReferPopup(false)} title = "Select an Affiliate to Refer" subTitle= "Choose Affiliate to refer"/>
          </Dialog>
      </>
    );
}

export function ManageTicketTableBody(props: any) {
    const CustomSelectDropdown = StyledSelectDropdown();
    const {list,isSelected, handleClick, handleIconClick, handleDropdownChange, selectedValues,publishATicket,setColumnTypes,setSortType,setCurrentPage} = props;    
    const [openDialog, setOpenDialog] = useState(false);
    const [rowIdpublishticket, setRowIdpublishticket] = useState("")
    const StyledComponent = CustomPaperComponent();
    const {globalState,handleGlobalState} = useContext<any>(globalContext)
    const [details, setDetails] = useState<any>({})
    const {UserEdit,EditListPriceDisable} = images
    const {success,error} = ToasterWithMessage()
    const [openDialogEdit,setOpenDialogEdit]=useState<boolean>(false);
    const [openDuplicateConfirm, setOpenDuplicateConfirm] = useState<boolean>(false);
    const [duplicateConfirmMsg, setDuplicateConfirmMsg] = useState<string>("");
    const [ticketEditDetails,setTicketEditDetails]=useState<EditTicketType>();
    const [pendingEditTicketInput, setPendingEditTicketInput] = useState<any>(null);
    const {superUserSet} = useSuperUsers();

    //closes the success pop
    const handleCloseDialog = () => {
      setOpenDialog(false);
      setRowIdpublishticket("")
    };
    
    const handleAllowpublish = (listPrice: number) =>{
        setOpenDialog(false)
        setColumnTypes("e_date");
        setSortType("desc");
        publishATicket(true,rowIdpublishticket, listPrice);
      setRowIdpublishticket("")
    }
    
    const handlepublish = (_value: boolean , row : manageticketsrowType) => {
      setOpenDialog(true)
      setRowIdpublishticket(row?.tp_id)
      setDetails(row)
    }

    /*For force edit the ticket*/
    const [ticketDetails] = useLazyQuery(GET_EDIT_TICKET_DETAIL,{
      fetchPolicy : "no-cache",
      onCompleted: (data) =>{
        setTicketEditDetails(data?.ticket_placement[0]);
        setOpenDialogEdit(true);
      },
      onError : () =>{
       error("Something went wrong!")
      }
    });

    const [updateTicketDetail] = useMutation(EDIT_TICKET,{
      fetchPolicy : "no-cache",
      onCompleted: (data) =>{
        if (data?.editTickets?.requiresConfirmation) {
          setDuplicateConfirmMsg(data?.editTickets?.message || "Matching ticket details exist. Do you want to proceed?");
          setOpenDuplicateConfirm(true);
          return;
        }
        if(data){
          success(data?.editTickets?.message);
          setColumnTypes("e_date");
          setSortType("desc");
          setCurrentPage(1);
          const tempState = {...globalState}
         tempState.ticketUpdate.updatedticket = true
         handleGlobalState(tempState)
        }
      },
      onError : (err) =>{
       error(err?.message);
      }
    });
    const handleOpenEdit = (row:manageticketsrowType)=>{
      ticketDetails({
        variables :{
          tp_id : row?.tp_id
        }
      })
    }

    const handleCloseEditTicket= () =>{
      setOpenDialogEdit(false)
    }
    const handleCloseDuplicateConfirm = () => {
      setOpenDuplicateConfirm(false);
      setOpenDialogEdit(true);
    }
    const handleAllowDuplicateConfirm = () => {
      setOpenDuplicateConfirm(false);
      if (pendingEditTicketInput) {
        updateTicketDetail({
          variables: {
            editTicketsInput: {
              ...pendingEditTicketInput,
              forceUpdate: true
            }
          }
        });
      }
    }

    const handleAllowEdit=(data:{section:string, row:string, seatno: string})=>{
      if(data && data?.section!==''&& data?.row!==''&& data?.seatno !== ''){
        const editInput = {
          e_id:ticketEditDetails?.ticket?.event?.e_id,
          tp_id:ticketEditDetails?.tp_id,
          tp_row:data?.row?.trim(),
          tp_section:data?.section?.trim(),
          tp_seat_no: parseInt(data?.seatno?.trim()),
          forceUpdate: false
        };
        setPendingEditTicketInput(editInput);
        setOpenDialogEdit(false);
          updateTicketDetail({
            variables:{
              editTicketsInput: editInput
            }
          })
      }
    }
console.log("SuperUserSet:", superUserSet);


    return (
        <TableBody className={styles.tablebodyStyle}>
              {list?.filtermanagetickets?.map((row: manageticketsrowType, index: number) => {
                const isItemSelected = isSelected(index);
                const labelId = `enhanced-table-checkbox-${index}`;
                const isSuperUser = superUserSet.has(row.u_id);
                return (
                  <StyledTableRow
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={index}
                    isSuperUserData={isSuperUser}
                    classes={{ root: styles.rowStyle }}
                  >
                    {globalState.profile.userRole !== roles.SUPER_USER &&(
                    <TableCell
                      padding="checkbox"
                      classes={{
                        root: styles.tablecell,
                      }}
                      size="small"
                    >
                    <Checkbox
                        onClick={(event) =>
                          handleClick(event, index, row?.tp_id)
                        }
                        className={row?.e_status === "date-tbd" ? styles.disabledCheckbox : ""}
                        disabled={row?.e_status === "date-tbd"}  
                        classes={{
                          colorPrimary: styles.unselectCheckbox,
                          checked: styles.selectedCheckbox,
                        }}
                        disableRipple
                        checked={isItemSelected}
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </TableCell>
                     )}
                    <TableCell size="small" className={styles.manageEvent}>
                        <div className={styles.manageename}>{row?.e_name ? row?.e_name : '-'}</div>
                        <div className={styles.leagueStyle}>
                        <div>{row?.l_name ? row?.l_name: "-"}</div>
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={styles.statusHyphen}>{" - "}</div>}
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={`${row?.e_status === 'closed' || row?.e_status === 'cancelled' || row?.e_status === 'postponed' ? styles.eventStatusForManage : ''}`}>
                        {row?.e_status==='time-tbd'?"TBD":row?.e_status}
                        </div>
                        }
                      </div>
                    </TableCell>
                    <TableCell size="small" className={styles.manageDateCell}>
                      <div className={styles.dateStyle}>

                        {(row?.e_date === null || row?.e_status === "date-tbd") ? (
                          <div className={styles.TbdForManage}>TBD</div>
                        ) : (
                          <>
                            <div>{checking(row?.e_date).date}</div>
                            <div>
                              {checking(row?.e_date).time}
                              <span className={styles.TbdForManage}>
                                {row?.e_status === 'time-tbd' ? "[ TBD ]" : ""}
                              </span>
                            </div>
                          </>
                        )}

                      </div>
                    </TableCell>
                    <TableCell size="small" className={styles.manageVenueCell}>
                      <div className={styles.venueStyle}>
                        {row?.e_address
                        ? <>
                            {splitLocationForVenue(row?.e_address)}
                          </>
                        : "-"
                         }
                       
                      </div>
                    </TableCell>
                    <TableCell size="small" className={styles.manageDateCell}>
                      <div className={styles.dateStyle}>

                        {(row?.e_date === null || row?.e_status === "date-tbd") ? (
                          <div className={styles.TbdForManage}>TBD</div>
                        ) : (
                          <>
                            <div>{checking(row?.e_date, row?.e_time_zone).date}</div>
                            <div>
                              {checking(row?.e_date, row?.e_time_zone).time}
                              <span className={styles.TbdForManage}>
                                {row?.e_status === "time-tbd" ? "[ TBD ]" : ""}
                              </span>
                            </div>
                          </>
                        )}

                      </div>
                    </TableCell>
                    <TableCell
                      size="small"
                      className={styles.manageTicketPlacement}
                    >
                      <TicketPlacements tickets={row} tableTitle = {"manageticket"}/>
                    </TableCell>
                    {globalState.profile.userRole !==roles.SUPER_USER &&

                   
                    <TableCell
                      size="small"
                      className={styles.manageSelectDropdown}
                    >
                      <CustomSelectDropdown
                        name={`validate${index}`}
                        key={index}
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        defaultValue={
                          row?.tp_validity_status === null || row?.tp_status === "DelistInProgress"
                            ? "select"
                            : row?.tp_validity_status === true ? 'valid': row?.tp_validity_status=== false ?  'invalid' :row?.tp_validity_status
                        }
                        disabled={(row?.e_date === null || row?.e_status === "date-tbd" || row?.e_status==='closed'|| row?.e_status==="cancelled") ? true : false}
                        value={selectedValues ? selectedValues[index] : null}
                        IconComponent={(props) => (
                          <div onClick={handleIconClick}>
                            <ExpandMore
                              style={{ color: "#5d75f8" }}
                              {...props}
                            />
                          </div>
                        )}
                        onChange={(e) =>
                          handleDropdownChange(e, index, row?.tp_id)
                        }
                        autoWidth={true}
                        variant="outlined"
                        displayEmpty
                        // classes={{ root: (validate === "") ? styles.selectMenuItem : styles.menuItems}}
                      >
                        <MenuItem
                          value={"select"}
                          disabled
                          className={styles.dropdownMenuItem}
                          selected
                        >
                          -Select-
                        </MenuItem>
                       <MenuItem
                          value={"valid"}
                          disabled={row?.tp_status==="DelistInProgress"||((row?.user?.u_role === 'user') && (row?.tp_status === 'Delist' ))}
                          className={styles.dropdownMenuItem}
                        >
                          Valid
                        </MenuItem>
                        <MenuItem
                          value={"invalid"}
                          disabled={(row?.user?.u_role === 'user') && (row?.tp_status === 'Delist' )}
                          className={styles.dropdownMenuItem}
                        >
                          Invalid
                        </MenuItem>
                      {(row?.tp_status==="DelistInProgress" || row?.tp_status==="Delist") &&
                        <MenuItem
                          value={"return"}
                          className={styles.dropdownMenuItem}
                        >
                          Return
                        </MenuItem>
                      }
                      {(row?.tp_status==="DelistInProgress") &&
                        <MenuItem
                          value={"ToBeVerified"}
                          className={styles.dropdownMenuItem}
                        >
                          To be verified
                        </MenuItem>
                      }
                      </CustomSelectDropdown>
                    </TableCell>
                    }
                    <TableCell size="small" className={styles.manageStatusCell}>
                      <span
                        className={
                          row?.tp_status === "ToBeVerified"
                            ? styles.statusVerified
                            : row?.tp_status === "Delist"
                            ? styles.statusDeactive
                            : row?.tp_status === "Verified"
                            ? styles.statusActive
                            : row?.tp_status === "DelistInProgress"
                            ? styles.statusDeactive
                            : styles.statusVerified
                        }
                        
                      >
                        {row?.tp_status === "ToBeVerified"
                          ? "To be verified"
                          : row?.tp_status === "Delist"
                          ? "Delist"
                          : row?.tp_status === "Verified"
                          ? "Verified"
                          : row?.tp_status === "DelistInProgress"
                          ? "Delist Requested"
                          : "To be verified"}
                      </span>
                    </TableCell>
                    {(globalState.profile.userRole !== roles.SUPER_USER)&&
                      <TableCell size="small" className={styles.manageStatusCell}>
                      <div className={styles.flexStyle}>
                          <span className={styles.statusVerified}>{row?.tp_is_support_vanderbilt_nil_fund ? 'Donated' : '-'}</span>
                      </div>
                      </TableCell>
                    }
                    <TableCell size="small" className={styles.manageVenueCell}>
                      <div className={styles.venueStyle}>
                        {row?.tp_delist_requested_email
                        ? <div>{row?.tp_delist_requested_email}</div>
                        : "-"
                         }
                       
                      </div>
                    </TableCell>
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.manageUserId}>
                      <span className={styles.customtableCell}>
                        {row?.full_name? row?.full_name : '-'}
                      </span>
                    </TableCell>}
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.manageUserId}>
                    <span className={styles.customtableCell}>
                    {row?.u_original_email?row?.u_original_email:row?.u_email_id? row?.u_email_id : '-'}
                       </span>
                       <span className={styles.customtableCell}>
                    {row?.u_original_email? ' [deleted user]': ''}
                       </span>
                    </TableCell>}
                    <TableCell size="small" className={styles.managePeriodLeft}>
                      {(row?.e_date === null || row?.e_status === "date-tbd") ? ( "-" ) : 
                        getTimeRemaining(row?.e_date,globalState.manageTicketFilter.currentdate) ? (
                        getTimeRemaining(row?.e_date,globalState.manageTicketFilter.currentdate).includes("Hour" || "Hours" || "Minutes") ? (
                          <span className={styles.hourPeriodStyle}>
                            {`${getTimeRemaining(row?.e_date,globalState.manageTicketFilter.currentdate)}`}
                          </span>
                        ) : (
                          <span className={styles.customtableCell}>
                            {`${getTimeRemaining(row?.e_date,globalState.manageTicketFilter.currentdate)}`}
                          </span>
                        )
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    {globalState.profile.userRole !== roles.SUPER_USER &&
                      <TableCell size="small" className={styles.stickyTableCell}>
                      <div style={{display: 'flex',justifyContent:'space-evenly',width:'100%'}}>
                        <div className={styles.publishBtn}>
                          <Button
                            // sx={{ color: "#b9bdc6" }}
                            classes={{ root: styles.separateStyle }}
                            disabled ={((row?.e_status==='closed'|| row?.e_status==="cancelled")|| row?.tp_status !== 'Verified') ? true : false}
                            fullWidth
                            onClick={(e) => handlepublish(true, row)}
                          >
                            Publish
                          </Button>
                        </div>
                        { (globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                        <div className={styles.editPriceBtn}>
                        <Button classes={{root: styles.editPriceSeparateStyle}} 
                        fullWidth onClick={(e)=>handleOpenEdit(row)} >
                          <img src={UserEdit} alt="useredit"/>
                        </Button>
                      </div>
                        }
                        </div>
                      </TableCell>
                    }
                  </StyledTableRow>
                );
              })}
              <Dialog
          open={openDialog}
          PaperComponent={StyledComponent}
        >
          <PublishPopupSingle row={details} handleCloseDialog={handleCloseDialog} handleAllow ={handleAllowpublish}/>
        </Dialog>
        <Dialog
          open={openDialogEdit}
          PaperComponent={StyledComponent}
        >
          <EditTicketPopUp ticketData={ticketEditDetails} handleCloseDialog={handleCloseEditTicket} handleAllow ={handleAllowEdit}/>
        </Dialog>
        <Dialog
          open={openDuplicateConfirm}
          PaperComponent={StyledComponent}
        >
          <PublishPopup
            title="Proceed with update?"
            subTitle={duplicateConfirmMsg}
            delist={true}
            handleAllow={handleAllowDuplicateConfirm}
            handleClose={handleCloseDuplicateConfirm}
          />
        </Dialog>
      </TableBody>       
    );
}

interface arrayValueType{
  eg_id: string,
  referral_amount: number,
  referral_type: string
}

export function ListTicketTableBody(props: any) {
  const {list, isSelected, handleClick, setColumnTypes, setSortType,setCurrentPage} = props;
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openDialogDelist, setOpenDialogDelist] = useState<boolean>(false);
  const [openDialogList, setOpenDialogList] = useState<boolean>(false);
  const [openDialogReturn, setOpenDialogReturn] = useState<boolean>(false);
  const [openDialogEditPrice, setOpenDialogEditPrice] = useState<boolean>(false);
  const [openDuplicateConfirmList, setOpenDuplicateConfirmList] = useState<boolean>(false);
  const [duplicateConfirmListMsg, setDuplicateConfirmListMsg] = useState<string>("");
  const [quickCutAmount,setQuickCutAmount] = useState<number>(0);
  const [markAsSoldFeeMode, setMarkAsSoldFeeMode] = useState<'super' | 'default'>('default');
  const [markAsSoldSuperClientPercent, setMarkAsSoldSuperClientPercent] = useState<number | null>(null);
  const [details, setDetails] = useState<any>({})
  const [pendingListEditInput, setPendingListEditInput] = useState<any>(null);
  const StyledComponent = CustomPaperComponent();
  const {success,error} = ToasterWithMessage()
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const {UserEdit,EditListPriceDisable} = images;
  const {superUserSet} = useSuperUsers();

  const [delistTicketByAdmin] = useMutation(DELIST_TICKET,{
    fetchPolicy: 'no-cache',
    onCompleted: (data) =>{
      setColumnTypes('e_date')
      setSortType('desc')
      success("Ticket Delisted Successfully")
      const tempState = {...globalState};
      tempState.ticketUpdate.delistTicket  = true
      handleGlobalState(tempState);
    },
    onError: () =>{
      error('Unable to Delist')
    }
  })
  const [returnTicketByAdmin] = useMutation(RETURN_TICKET,{
    fetchPolicy: 'no-cache',
    onCompleted: (data) =>{
      if(data?.returnTickets?.message){
      setColumnTypes('e_date')
      setSortType('desc')
      success(data?.returnTickets?.message)
      const tempState = {...globalState};
      tempState.ticketUpdate.returnTicket = true
      handleGlobalState(tempState);
      }
    },
    onError: (err) =>{
      error(err?.message)
    }
  })

  const [listTicketByAdmin] = useMutation(UNDO_DELIST_REQUEST_TO_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) =>{
      if(data?.undoDelistRequestToList?.message){
      setColumnTypes('e_date')
      setSortType('desc')
      success(data?.undoDelistRequestToList?.message)
      const tempState = {...globalState};
      tempState.ticketUpdate.listTicket  = true
      handleGlobalState(tempState);
      }
    },
    onError: (err) =>{
      error(err?.message)
    }
  })
  const [updateTicketStatus] = useMutation(VALIDATE_UPDATE,{
    fetchPolicy : 'no-cache',
    onCompleted:(data) =>{
      setColumnTypes('e_date')
      setSortType('desc')
      success("Ticket Delisted Successfully")
      const tempState = {...globalState};
      tempState.ticketUpdate.delistTicket  = true
      handleGlobalState(tempState);
    },
    onError: () =>{
      error('Unable to Delist')
    }
  })
  const [getBonusAmounts] = useLazyQuery(GET_BONUS_AMOUNTS,{
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      // eslint-disable-next-line array-callback-return
      data?.earning_configuration.map((value : arrayValueType) => {
         if(value?.referral_type === 'quick_cut'){
            setQuickCutAmount(value?.referral_amount);
          }
      })
    }
  });

  const [getSuperUser] = useLazyQuery(GET_SUPER_USER_BY_UID, {
    fetchPolicy: 'no-cache',
  });

  const [editTicketDetail] = useMutation(EDIT_TICKET,{
    fetchPolicy : 'no-cache',
    onCompleted:(data) =>{
      if (data?.editTickets?.requiresConfirmation) {
        setDuplicateConfirmListMsg(data?.editTickets?.message || "Matching ticket details exist. Do you want to proceed?");
        setOpenDuplicateConfirmList(true);
        return;
      }
      success(data?.editTickets?.message);
      setColumnTypes("e_date");
      setSortType("desc");
      setCurrentPage(1);
      const tempState = {...globalState};
      tempState.ticketUpdate.listPrice  = true
      handleGlobalState(tempState);
    },
    onError: (err) =>{
      error(err.message)
    }
  })
  const handleCloseDialog = () => {
        setOpenDialog(false);
  }
  const handleCloseDialogDelist = () =>{
        setOpenDialogDelist(false)
  }
  const handleCloseDialogList = () =>{
    setOpenDialogList(false)
  }
  const handleCloseDialogReturn = () =>{
    setOpenDialogReturn(false)
}
  const handleCloseDialogEditPrice = () =>{
    setOpenDialogEditPrice(false)
}
  const handleCloseDuplicateConfirmList = () => {
    setOpenDuplicateConfirmList(false);
    setOpenDialogEditPrice(true);
  }
  const handleAllowDuplicateConfirmList = () => {
    setOpenDuplicateConfirmList(false);
    if (pendingListEditInput) {
      editTicketDetail({
        variables: {
          editTicketsInput: {
            ...pendingListEditInput,
            forceUpdate: true
          }
        }
      });
    }
  }
  const handleOpenDialog = async(row: listTicketsRowType) =>{
        setDetails(row);
        const { data } =await getSuperUser({variables:{u_id:row.u_id}});
        const su = data?.super_user?.[0];
        if(su?.u_id){
          setMarkAsSoldFeeMode('super');
          setMarkAsSoldSuperClientPercent(parseFloat(String(su.percentage ?? '0')));
          setQuickCutAmount(0);
        }else{
          setMarkAsSoldFeeMode('default');
          setMarkAsSoldSuperClientPercent(null);
          await getBonusAmounts();
        }  
        setOpenDialog(true); 
  }
  
  const handleOpenDialogDelist = (row : listTicketsRowType) =>{
        setOpenDialogDelist(true)
        setDetails(row)
  }

  const handleOpenDialogList = (row : listTicketsRowType) =>{
    setOpenDialogList(true)
    setDetails(row)
  }

  const handleOpenDialogReturn = (row : listTicketsRowType) =>{
    setOpenDialogReturn(true)
    setDetails(row)
}

  const handleOpenEditListPrice = (row : listTicketsRowType) => {
    setOpenDialogEditPrice(true)
    setDetails(row)
  }

  const handleAllowDelist = (event : React.MouseEvent<HTMLButtonElement>) =>{
    event.preventDefault()
    if(event){
      setOpenDialogDelist(false)
      if(details?.tp_status === 'DelistInProgress'){
        delistTicketByAdmin({
          variables:{
            ticketPlacementId: details?.tp_id
          }
        })
      }else if(details?.tp_status === 'List'){
        updateTicketStatus({
          variables:{
            isValid: false,
            ticketPlacementId: [details?.tp_id]
          }
        })
      }
    }
  }

  const handleAllowList = (event : React.MouseEvent<HTMLButtonElement>) =>{
    event.preventDefault();
    if(event){
      setOpenDialogList(false)
      if(details?.tp_status === 'DelistInProgress'){
        listTicketByAdmin({
          variables:{
            tpId: details?.tp_id
          }
        })
      }
    }
  }

  const handleAllowReturn = (event : React.MouseEvent<HTMLButtonElement>) =>{
    event.preventDefault()
    if(event){
      setOpenDialogReturn(false)
      if(details?.tp_status === 'DelistInProgress'){
        returnTicketByAdmin({
          variables:{
            ticketPlacementId: details?.tp_id
          }
        })
      }
    }
  }

  const handleAllowEditPrice=(data: { listPrice: string, section: string, rows: string, seatno: string, tp_id: string, e_id: string })=>{
    if(data.listPrice && data.listPrice!==''){
      const editInput = {
        e_id: data?.e_id,
        tp_id: data?.tp_id,
        tp_row: data?.rows?.trim(),
        tp_section: data?.section?.trim(),
        tp_seat_no: parseInt(data?.seatno?.trim()),
        tp_list_price: parseFloat(data?.listPrice),
        forceUpdate: false
      };
      setPendingListEditInput(editInput);
      setOpenDialogEditPrice(false);
        editTicketDetail({
          variables:{
            editTicketsInput: editInput
          }
        })
    }
  }
  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
              {list?.filterlisttickets?.map((row: listTicketsRowType, index: number) => {
                const isItemSelected = isSelected(index);
                const labelId = `enhanced-table-checkbox-${index}`;
                const isSuperUser = superUserSet.has(row.u_id);
                return (
                  <StyledTableRow
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={index}
                    isSuperUserData={isSuperUser}
                    classes={{root: styles.rowStyle}}
                  >
                    {globalState.profile.userRole === roles.SUPER_USER &&(
                    <TableCell
                      padding="checkbox"
                      classes={{
                        root: styles.tablecell,
                      }}
                      size="small"
                    >
                      <Checkbox
                        onClick={(event) => handleClick(event, index, row?.tp_id)}
                        classes={{
                          colorPrimary: styles.unselectCheckbox,
                          checked: styles.selectedCheckbox,
                        }}
                        disableRipple
                        checked={isItemSelected}
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </TableCell>
                     )}
                    <TableCell size="small" className={styles.listEventCell}>
                        <div>{row?.e_name ? row?.e_name : '-'}</div>
                        <div className={styles.leagueStyleForlist}>
                        <div>{row?.l_name ? row?.l_name: "-"}</div>
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={styles.statusHyphenForList}>{" - "}</div>}
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={`${row?.e_status === 'closed' || row?.e_status === 'cancelled' || row?.e_status === 'postponed' ? styles.eventStatusForList : ''}`}>
                        {row?.e_status==='time-tbd'?"TBD":row?.e_status}
                        </div>
                        }
                      </div>
                    </TableCell>
                    <TableCell size="small" className={styles.listDateCell}>
                    <div className={styles.listdateStyle}>
                      <div>{checking(row?.e_date).date}</div>
                      <div>{checking(row?.e_date).time} <span className={styles.TbdForList}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.listVenueCell}>
                    <div className={styles.listvenueStyle}>
                      {
                        row?.e_address 
                      ? <>
                          {splitLocationForVenue(row?.e_address)}
                        </>
                      : "-"
                      }
                      
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.listDateCell}>
                    <div className={styles.listdateStyle}>
                      <div>{checking(row?.e_date,row?.e_time_zone).date}</div>
                      <div>{checking(row?.e_date,row?.e_time_zone).time} <span className={styles.TbdForList}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.listTicketPlacementCell}>
                   <TicketPlacements tickets={row} tableTitle = {"listticket"}/>
                    </TableCell>
                    <TableCell size="small" className={styles.manageStatusCell}>
                      <span
                        className={
                            row?.tp_status === "List"
                            ? styles.statusActive
                            : row?.tp_status === "DelistInProgress"
                            ? styles.statusDeactive :''
                        }
                        
                      >
                        {
                           row?.tp_status === "List"
                          ? "Listed"
                          : row?.tp_status === "DelistInProgress"
                          ? "Delist Requested"
                          : ""}
                      </span>
                    </TableCell>
                    {(globalState.profile.userRole !== roles.SUPER_USER)&&
                      <TableCell size="small" className={styles.manageStatusCell}>
                      <div className={styles.flexStyle}>
                          <span className={styles.statusVerified}>{row?.tp_is_support_vanderbilt_nil_fund ? 'Donated' : '-'}</span>
                      </div>
                      </TableCell>
                    }
                    <TableCell size="small" className={styles.listVenueCell}>
                    <div className={styles.listvenueStyle}>
                        {row?.tp_delist_requested_email
                        ? <div>{row?.tp_delist_requested_email}</div>
                        : "-"
                         }
                      </div>
                    </TableCell>
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.listUserIdCell}>
                    <span className={styles.customtableCell}> {row?.u_full_name ? row?.u_full_name : '-'} </span>
                    </TableCell>}
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.listUserIdCell}>
                    <span className={styles.customtableCell}>
                    {row?.u_original_email?row?.u_original_email:row?.u_email_id? row?.u_email_id : '-'}
                       </span>
                       <span className={styles.customtableCell}>
                    {row?.u_original_email? ' [deleted user]': ''}
                       </span>
                    </TableCell>}
                    <TableCell size="small" className={styles.listUserIdCell}>
                    <span className={styles.customtableCell}> {`${row?.tp_list_price}` ? `$${formatNumberWithCommas(row?.tp_list_price)}` : `'-'`} </span>
                    </TableCell>
                     {globalState.profile.userRole !== roles.SUPER_USER &&(
                    <TableCell
                      size="small"
                      className={styles.stickyTableCellForlist}
                    >
                      <div style={{display: 'flex',justifyContent:'space-evenly',width:'100%',gap: '12px'}}>
                      <div className={styles.delistbtn}>
                      <Button classes={{root: styles.separateStyle}} sx={{color: '#ef4444'}}  fullWidth onClick={(e)=>handleOpenDialogDelist(row)}>Delist</Button>
                    </div>
                   
                        <div className={styles.markAsSoldBtn}>
                        <Button classes={{root: styles.separateStyle}} sx={{color: '#22c55e'}} disabled={row?.tp_status !=="DelistInProgress"} fullWidth onClick={(e)=>handleOpenDialogList(row)}>List</Button>
                        </div>
                            <div className={styles.returnbtn}>
                              <Button classes={{root: styles.separateStyle}} sx={{color: '#ffbf00'}} fullWidth disabled={row?.tp_status!=="DelistInProgress"} onClick={(e)=>handleOpenDialogReturn(row)}>Return</Button>
                            </div>
                            <div className={styles.markAsSoldBtn}>
                              <Button classes={{root: styles.separateStyle}} sx={{color: '#22c55e'}} disabled={row?.tp_status ==="Delist"} fullWidth onClick={(e)=>handleOpenDialog(row)}>Sold</Button>
                            </div>
                          <div className={styles.editPriceBtn}>
                            <Button classes={{root: styles.editPriceSeparateStyle}} disabled={row?.tp_status!=="List"} fullWidth onClick={(e)=>handleOpenEditListPrice(row)}>
                              {row?.tp_status!=="List"?
                              <img src={EditListPriceDisable} alt="usereditDisable"/>:
                              <img src={UserEdit} alt="useredit"/>
                              } 
                            </Button>
                          </div>     
                    </div>
                    </TableCell>
                    )}
                  </StyledTableRow>
                );
              })}
              </TableBody>
              <Dialog
                open={openDialog}
                PaperComponent={StyledComponent}
              >
               <MarkAsSold row={details} handleCloseDialog={handleCloseDialog} setColumnTypes = {setColumnTypes} setSortType = {setSortType} feeMode={markAsSoldFeeMode} superClientPercent={markAsSoldSuperClientPercent} defaultQuickCutPercent={quickCutAmount}/>
              </Dialog>
              <Dialog
                open={openDialogDelist}
                PaperComponent={StyledComponent}
              >
              <PublishPopup title="Delist?" subTitle="Kindly confirm - Once you removed from all platforms where it's currently listed" delist={true} handleAllow={handleAllowDelist} handleClose={handleCloseDialogDelist}/>
              </Dialog>
              <Dialog
                open={openDialogList}
                PaperComponent={StyledComponent}
              >
              <PublishPopup title="Move to List?" subTitle="Kindly confirm - Do you want to move this ticket to List?" delist={true} handleAllow={handleAllowList} handleClose={handleCloseDialogList}/>
              </Dialog>
              <Dialog
                open={openDialogReturn}
                PaperComponent={StyledComponent}
              >
              <PublishPopup title="Return?" subTitle="Kindly confirm - Once you returned the ticket to the sender" returnTicket={true} handleAllow={handleAllowReturn} handleClose={handleCloseDialogReturn}/>
              </Dialog>
              <Dialog
          open={openDialogEditPrice}
          PaperComponent={StyledComponent}
        >
          <EditPricePopUp row={details} handleCloseDialog={handleCloseDialogEditPrice} handleAllow ={handleAllowEditPrice}/>
        </Dialog>
        <Dialog
          open={openDuplicateConfirmList}
          PaperComponent={StyledComponent}
        >
          <PublishPopup
            title="Proceed with update?"
            subTitle={duplicateConfirmListMsg}
            delist={true}
            handleAllow={handleAllowDuplicateConfirmList}
            handleClose={handleCloseDuplicateConfirmList}
          />
        </Dialog>
    </>
  );
}

export function DelistAndReturnTicketTableBody(props: any) {
  const {list, isSelected, setColumnTypes, setSortType} = props;
  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const {superUserSet} = useSuperUsers();

  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
              {list?.filterreturntickets?.map((row: listTicketsRowType, index: number) => {
                const isItemSelected = isSelected(index);
                const isSuperUser = superUserSet.has(row.u_id);
                return (
                  <StyledTableRow
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={index}
                    isSuperUserData={isSuperUser}
                    classes={{root: styles.rowStyle}}
                  >
                    <TableCell size="small" className={styles.returnEventCell}>
                        <div>{row?.e_name ? row?.e_name : '-'}</div>
                        <div className={styles.leagueStyleForReturn}>
                        <div>{row?.l_name ? row?.l_name: "-"}</div>
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={styles.statusHyphenForReturn}>{" - "}</div>}
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={`${row?.e_status === 'closed' || row?.e_status === 'cancelled' || row?.e_status === 'postponed' ? styles.eventStatusForReturn : ''}`}>
                        {row?.e_status==='time-tbd'?"TBD":row?.e_status}
                        </div>
                        }
                      </div>
                    </TableCell>
                    <TableCell size="small" className={styles.returnDateCell}>
                    <div className={styles.returndateStyle}>
                      <div>{checking(row?.e_date).date}</div>
                      <div>{checking(row?.e_date).time} <span className={styles.TbdForReturn}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.returnVenueCell}>
                    <div className={styles.returnvenueStyle}>
                      {
                        row?.e_address 
                      ? <>
                          {splitLocationForVenue(row?.e_address)}
                        </>
                      : "-"
                      }
                      
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.returnVenueCell}>
                    <div className={styles.returnvenueStyle}>
                      {
                        row?.tp_delist_requested_email 
                      ? <div>{row?.tp_delist_requested_email}</div>
                      : "-"
                      }
                      
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.returnDateCell}>
                    <div className={styles.returndateStyle}>
                      <div>{checking(row?.e_date,row?.e_time_zone).date}</div>
                      <div>{checking(row?.e_date,row?.e_time_zone).time} <span className={styles.TbdForReturn}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.returnTicketPlacementCell}>
                   <TicketPlacements tickets={row} tableTitle = {"delistandreturnticket"}/>
                    </TableCell>
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.returnUserIdCell}>
                    <span className={styles.customtableCell}> {row?.u_full_name ? row?.u_full_name : '-'} </span>
                    </TableCell>}
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.returnUserIdCell}>
                    <span className={styles.customtableCell}>
                    {row?.u_original_email?row?.u_original_email:row?.u_email_id? row?.u_email_id : '-'}
                       </span>
                       <span className={styles.customtableCell}>
                    {row?.u_original_email? ' [deleted user]': ''}
                       </span>
                    </TableCell>}
                    {(globalState.profile.userRole !== roles.SUPER_USER)&&
                      <TableCell size="small" className={styles.manageStatusCell}>
                      <div className={styles.flexStyle}>
                          <span className={styles.statusVerified}>{row?.tp_is_support_vanderbilt_nil_fund ? 'Donated' : '-'}</span>
                      </div>
                      </TableCell>
                    }
                  </StyledTableRow>
                );
              })}
              </TableBody>
    </>
  );
}

export function DelistAndUnsoldTicketTableBody(props: any) {
  const {list, isSelected, setColumnTypes, setSortType} = props;
  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const {superUserSet} = useSuperUsers();

  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
              {list?.filterUnsoldTickets?.map((row: listTicketsRowType, index: number) => {
                const isItemSelected = isSelected(index);
                const isSuperUser = superUserSet.has(row.u_id);
                return (
                  <StyledTableRow
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={index}
                    isSuperUserData={isSuperUser}
                    classes={{root: styles.rowStyle}}
                  >
                    <TableCell size="small" className={styles.unsoldEventCell}>
                        <div>{row?.e_name ? row?.e_name : '-'}</div>
                        <div className={styles.leagueStyleForUnsold}>
                        <div>{row?.l_name ? row?.l_name: "-"}</div>
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={styles.statusHyphenForUnsold}>{" - "}</div>}
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={`${row?.e_status === 'closed' || row?.e_status === 'cancelled' || row?.e_status === 'postponed' ? styles.eventStatusForUnsold : ''}`}>
                        {row?.e_status==='time-tbd'?"TBD":row?.e_status}
                        </div>
                        }
                      </div>
                    </TableCell>
                    <TableCell size="small" className={styles.unsoldDateCell}>
                    <div className={styles.unsolddateStyle}>
                      <div>{checking(row?.e_date).date}</div>
                      <div>{checking(row?.e_date).time} <span className={styles.TbdForUnsold}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.unsoldVenueCell}>
                    <div className={styles.unsoldvenueStyle}>
                      {
                        row?.e_address 
                      ? <>
                          {splitLocationForVenue(row?.e_address)}
                        </>
                      : "-"
                      }
                      
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.unsoldDateCell}>
                    <div className={styles.unsolddateStyle}>
                      <div>{checking(row?.e_date,row?.e_time_zone).date}</div>
                      <div>{checking(row?.e_date,row?.e_time_zone).time} <span className={styles.TbdForUnsold}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.unsoldTicketPlacementCell}>
                   <TicketPlacements tickets={row} tableTitle = {"delistandunsoldticket"}/>
                    </TableCell>
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.unsoldUserIdCell}>
                    <span className={styles.customtableCell}> {row?.u_full_name ? row?.u_full_name : '-'} </span>
                    </TableCell>}
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.unsoldUserIdCell}>
                    <span className={styles.customtableCell}>
                    {row?.u_original_email?row?.u_original_email:row?.u_email_id? row?.u_email_id : '-'}
                       </span>
                       <span className={styles.customtableCell}>
                    {row?.u_original_email? ' [deleted user]': ''}
                       </span>
                    </TableCell>}
                    {(globalState.profile.userRole !== roles.SUPER_USER)&&                    
                      <TableCell size="small" className={styles.manageStatusCell}>
                      <div className={styles.flexStyle}>
                          <span className={styles.statusVerified}>{row?.tp_is_support_vanderbilt_nil_fund ? 'Donated' : '-'}</span>
                      </div>
                      </TableCell>
                    }
                  </StyledTableRow>
                );
              })}
              </TableBody>
    </>
  );
}


export function SoldTicketTableBody(props: any) {
  const {list, isSelected, setCurrentPage, setColumnTypes, setSortType} = props;
  const { Invoice, Payout, PayoutInprogress, DollarCross, DollarTick } = images;
  const [openDialogForInvoice, setOpenDialogforInvoice] = useState<boolean>(false);
  const [openDialogForVoidPayout, setOpenDialogforVoidPayout] = useState<boolean>(false);
  const [details, setDetails] = useState<any>({})
  const [detailsForVoidedPayout, setDetailsForVoidedPayout] = useState<any>({});
  const [openPopup, setOpenPopup] = useState<boolean>(false)
  const [tpId, setTpId] = useState<string>('')
  const {success,error} = ToasterWithMessage()
  const {globalState,handleGlobalState} = useContext<any>(globalContext);
const {superUserSet} = useSuperUsers();
    const StyledComponent = CustomPaperComponent();
    const navigate = useNavigate()
    const handleCloseDialogforInvoice = () => {
          setOpenDialogforInvoice(false);
          setOpenPopup(false)
    }
    const handleOpenDialogforInvoice = (row: soldTicketsRowType) =>{
          setOpenDialogforInvoice(true);
          setDetails(row)
          setOpenPopup(true)
    }
    const handleAllowVoidPayout = () => {
      voidUnvoidPayout({
        variables: {
          tpId
        }
      })
      setOpenDialogforVoidPayout(false);
    }

    const handleCloseDialog = () => {
      setOpenDialogforVoidPayout(false);
    }

    const [autoPayoutTicket] = useMutation(AUTO_PAYOUT,{
      onCompleted : (data) => {
        const tempState = { ...globalState };
        tempState.loadingForAutoPayout.AutoPayoutLoader = false;
        handleGlobalState(tempState);
         if(data?.transferAmountToUsersByTicket?.message === "Payment Success"){
            setCurrentPage(1);
            setColumnTypes("e_date");
            setSortType("desc");
            success("Payment completed successfully")
         }else if(data?.transferAmountToUsersByTicket?.message.toLowerCase().includes("insufficient")){
           error("You have insufficient available funds in your Stripe account")
         }
          else{
          error("Payment Failed")
         }
         const tempdata = {...globalState}
         tempdata.payoutTicket.payment = true
         handleGlobalState(tempdata)
      },
      onError : (er) =>{
        const tempState = { ...globalState };
        tempState.loadingForAutoPayout.AutoPayoutLoader = false;
        handleGlobalState(tempState);
        error(er.message)
      }
    })


    const [voidUnvoidPayout] = useMutation(UPDATE_TP_PAYOUT_STATUS,{
      onCompleted : (data) => {
        setCurrentPage(1);
        setColumnTypes("e_date");
        setSortType("desc");
        const tempdata = {...globalState}
        tempdata.loadingForVoidedPayout.voidedPayoutLoader = true
        handleGlobalState(tempdata)
        success(data?.updateTpPayoutStatus?.message ?? 'Payout status updated Successfully');
      },
      onError : (er) =>{
        const tempState = { ...globalState };
        tempState.loadingForVoidedPayout.voidedPayoutLoader = false;
        handleGlobalState(tempState);
        error(er.message)
      }
    })

    const handleClickFailed = (row : soldTicketsRowType) =>{
      if(row?.tp_payment_status === 'Failed'){
        const tempData = {...globalState}
        tempData.soldTickets.failed = true
        tempData.soldTickets.emailId = row?.u_email_id
        tempData.globalSearch.searchtext = row?.u_email_id
        handleGlobalState(tempData)
        navigate('/logs')
      }
    }

    const handleclickAutoPayout = (row: soldTicketsRowType) => {
      const tempState = {...globalState};
      tempState.loadingForAutoPayout.AutoPayoutLoader = true;
      handleGlobalState(tempState)
      autoPayoutTicket({
        variables: {
          ticketPlacementId: row?.tp_id,
        },
      });
    };

    const handleVoidUnVoidPayout = (row: soldTicketsRowType) => {
      setOpenDialogforVoidPayout(true);
      setDetailsForVoidedPayout(row)
      setTpId(row.tp_id);
    }
       
  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
              {list?.FilterSoldTickets?.map((row: soldTicketsRowType, index: number) => {
                const isItemSelected = isSelected(index);
                const isSuperUser = superUserSet.has(row.u_id);
                return (
                  <StyledTableRow
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={index}
                    isSuperUserData={isSuperUser}
                    classes={{root: styles.rowStyle}}
                  >
                    <TableCell size="small" className={styles.soldEventCell}>
                        <div className={styles.soldename}>{row?.e_name ? row?.e_name : '-'}</div>
                        <div className={styles.leagueStyleForSold}>
                        <div>{row?.l_name ? row?.l_name: "-"}</div>
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={styles.statusHyphenForSold}>{" - "}</div>}
                        {(row?.l_name && row?.e_status && (row?.e_status==="closed"|| row?.e_status==="cancelled"|| row?.e_status==="postponed"|| row?.e_status==="time-tbd")) && <div className={`${row?.e_status === 'closed' || row?.e_status === 'cancelled' || row?.e_status === 'postponed' ? styles.eventStatusForSold : ''}`}>
                        {row?.e_status==='time-tbd'?"TBD":row?.e_status}
                        </div>
                        }
                      </div>
                    </TableCell>
                    <TableCell size="small" className={styles.soldDateCell}>
                    <div className={styles.solddateStyle}>
                      <div>{checking(row?.e_date).date}</div>
                      <div>{checking(row?.e_date).time} <span className={styles.TbdForSold}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.soldVenueCell}>
                    <div className={styles.soldvenueStyle}>
                      {
                        row?.e_address 
                      ? <>
                          {splitLocationForVenue(row?.e_address)}
                        </>
                      : "-"
                      }
                    
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.soldDateCell}>
                    <div className={styles.solddateStyle}>
                      <div>{checking(row?.e_date,row?.e_time_zone).date}</div>
                      <div>{checking(row?.e_date,row?.e_time_zone).time} <span className={styles.TbdForSold}>{row?.e_status==='time-tbd'?"[ TBD ]":''}</span></div>
                    </div>
                    </TableCell>
                    <TableCell size="small" className={styles.soldTicketPlacementCell}>
                   <TicketPlacements tickets={row} tableTitle = {"soldticket"}/>
                    </TableCell>
                    <TableCell
                      size="small"
                      className={styles.manageStatusCell}
                      onClick={(globalState.profile.userRole === roles.ADMIN || globalState.profile.userRole === roles.AFFILIATER_ADMIN) ?()=>{handleClickFailed(row)}:undefined}
                    >                   
                     <span className={(row?.tp_payment_status === 'Success'||(row?.tp_payment_status === null && row?.tp_status==="Sold"))? row?.tp_payout_status === PayoutType.VOIDED_PAYOUT ? styles.voidedPayout : styles.statusActive : row?.tp_payment_status === 'Inprogress'?styles.statusVerified: row?.tp_payment_status === "Failed" ? globalState.profile.userRole==='admin'? row?.tp_payout_status === PayoutType.VOIDED_PAYOUT ? styles.voidedPayout : styles.statusFailed :styles.statusFailedForLogitix:''}>
                      {row?.tp_payment_status === null && row?.tp_status==="Sold" ? row?.tp_payout_status === PayoutType.UNVOIDED_PAYOUT ? 'Sold' : row?.tp_payout_status?.replace('_',' ') :row?.tp_payment_status === 'Success' ? 'Settled' :row?.tp_payment_status === 'Inprogress'?'Settlement In Progress': row?.tp_payout_status === PayoutType.VOIDED_PAYOUT ? row?.tp_payout_status?.replace('_',' ') : row?.tp_payment_status }</span>
                    </TableCell>
                    {(globalState.profile.userRole !== roles.SUPER_USER)&&                    
                      <TableCell size="small" className={styles.manageStatusCell}>
                      <div className={styles.flexStyle}>
                          <span className={styles.statusVerified}>{row?.tp_is_support_vanderbilt_nil_fund ? 'Donated' : '-'}</span>
                      </div>
                      </TableCell>
                    }
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.listUserIdCell}>
                    <span className={styles.customtableCell}> {row?.u_full_name? row?.u_full_name: '-'}</span>
                    </TableCell>}
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
                    <TableCell size="small" className={styles.listUserIdCell}>
                    <span className={styles.customtableCell}> {row?.u_email_id}</span>
                    </TableCell>}
                    <TableCell
                      size="small"
                      className={styles.stickyTableCell}
                    >
                       {(globalState.profile.userRole !==roles.SUPER_USER) ?(
                   <div style = {{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                   <div className={styles.soldPrice}>
                   <div className={styles.soldAmount}>{row?.tp_list_price ? ` $${row?.tp_list_price.toLocaleString('en-US')} `: '-'}</div>
                   <div className={styles.line}></div>
                    <div className={styles.soldAmount}>{row?.tp_logitix_amount ? ` $${row?.tp_logitix_amount.toLocaleString('en-US')} `: '-'}</div>
                    <div className={styles.line}></div>
                    <div className={styles.soldAmount}>{row?.tp_quick_cut_amount ? ` $${row?.tp_quick_cut_amount.toLocaleString('en-US')} `: '-'}</div>
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                    <div className={styles.line}></div>}
                    {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                    <div className={styles.invoiceIcon} onClick={(e)=>handleOpenDialogforInvoice(row)}>{row?.tp_payment_status==='Success'?<img src={Invoice} alt="invoiceicon"/>:row?.tp_payment_status==='Inprogress'?<img src={PayoutInprogress} alt="PayoutInprogress"/>:<img src={Payout} alt="payoutbutton"/>}</div>}
                    {
                    (globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                    row?.tp_payment_status === null &&
                    <div className={styles.line}></div>
                    }
                   </div>
                   <div className={styles.soldPrice}>
                    {
                      (globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                      row?.tp_payment_status === null &&
                      <>
                      <div className={styles.invoiceIcon} onClick={(e)=>handleVoidUnVoidPayout(row)}>{row?.tp_payout_status===PayoutType.VOIDED_PAYOUT?<img src={DollarCross} alt="UnvoidedIcon" width = {50}/>:<img src={DollarTick} alt="VoidedIcon" width = {50}/>}</div>
                      </>
                    }
                   </div>
                   </div>):(
                    <div style = {{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <div className={styles.soldPrice}>
                      <div className={styles.soldAmount}>{row?.tp_sold_amount ? ` $${row?.tp_sold_amount.toLocaleString('en-US')} `: '-'}</div>
                      </div>
                   </div>
                   )}
                 
                    </TableCell>
                  </StyledTableRow>
                );
              })}
              </TableBody>
              <Dialog
                  open={openDialogForInvoice}
                  PaperComponent={StyledComponent}
                >
                 <InvoicePopup row={details} handleCloseDialog={handleCloseDialogforInvoice} setCurrentPage={setCurrentPage} openPopup={openPopup} setColumnTypes = {setColumnTypes} setSortType = {setSortType}/>
                </Dialog>

              <Dialog
                  open={openDialogForVoidPayout}
                  PaperComponent={StyledComponent}
                >
                <PublishPopup
                  handleClose={handleCloseDialog}
                  title={`${detailsForVoidedPayout?.tp_payout_status === PayoutType.VOIDED_PAYOUT ? 'Unvoided Payout' : 'Voided Payout'}?`}
                  subTitle={`Do you want to ${detailsForVoidedPayout?.tp_payout_status === PayoutType.VOIDED_PAYOUT ? 'resume' : 'hold'} the payment`}
                  handleAllow ={handleAllowVoidPayout}
                  voidPayout = {true}
                />              
              </Dialog>
    </>
  );
}

interface affiliateByIdUsers {
  u_referral_link: string,
  u_is_active: boolean
}

interface affiliates {
  a_first_name: string,
  a_last_name : string,
  a_email_id : string,
  a_id : string,
  a_type: string,
  user: affiliateByIdUsers
}

export interface affiliateViewById {
    aId: string,
    aType: string,
    aStatus: string,
    emailId: string,
    firstName: string,
    lastName: string,
    referredBy: string,
    referralUrl: string,
    referralCode: string,
    referredById: string,
    isSupportVanderbiltNILFund: boolean,
    aOrganization: string
}
export interface affiliateById {
  affiliates_by_pk: affiliates
}
export function AffiliateUsersTableBody(props :any){
    const {list, isSelected, setCurrentPage,setColumnTypes,setSortType,affiliateDetailsView,setAffiliateDetailsView} = props;
    const {ReferalIcon,UserEdit} = images
    const [affiliateDetails, setAffiliateDetails] = useState<affiliateViewById>()
    const StyledComponent = CustomPaperComponent();
    const StyledComponentForFitContent = CustomPaperComponent(true);
    const [openDialogEdit, setOpenDialogEdit] = useState<boolean>(false);
    const [isAffiliatesDialogOpen, setIsAffiliateDialogOpen] = useState<boolean>(false);
    const {globalState,handleGlobalState} = useContext<any>(globalContext)
    const [openReferralUrlPopup, setOpenReferralUrlPopup] = useState<boolean>(false)
   const [deleteConfirm, setDeleteConfirm] = useState<boolean>(false)
   const [referrerId, setReferrerId] = useState<string | null>(null);
    const {success,error} = ToasterWithMessage();
    const navigate = useNavigate();
    const [getAffiliateById] = useLazyQuery(GET_AFFILIATE_BY_ID_DIRECT_INDIRECT,{
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        setAffiliateDetails(data?.GetAffiliateById?.[0]);
      }
    })

    const [deleteAffiliate] = useMutation(DELETE_AFFILIATE,{
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        setColumnTypes("aUpdatedAt");
        setSortType("desc");
        success("Affiliate Deleted Successfully")
        const tempState = {...globalState};
        tempState.affiliateDelete.deleted = true;
        handleGlobalState(tempState);
        setAffiliateDetails(undefined);
      },
      onError: () => {
        error("Affiliate user not deleted");
      }
    })
    
    const handleClickEditAffiliate = (row : getAffiliates) =>{
      setOpenDialogEdit(true)
      getAffiliateById({
        variables: {
          aId: row?.aId
        }
      });
    }
    const handleCloseEditAffiliate = () =>{
       setOpenDialogEdit(false)
    }
    const handleClickViewReferralUrl = (row : getAffiliates) => {
      setOpenReferralUrlPopup(true);
      getAffiliateById({
        variables: {
          aId: row?.aId
        }
      });
    }

    const handleClickViewAffiliateDetails = (row: getAffiliates) => {
      setAffiliateDetailsView(true);
      navigate(`/affiliate/transactions/${row.uId}`, {state: { id: row?.uId, aType: row?.aType}});
    }
    const handleCloseReferralDialog = () => {
      setOpenReferralUrlPopup(false);
    }

    const handleShowNumberOfUsers = (row : getAffiliates) => {
       const tempData = {...globalState};
       tempData.affiliateNumberOfUsers.numberOfUsers =  row?.noOfUsers || 0;

       tempData.globalSearch.searchtext = row?.referralCode;
       tempData.globalSearch.affiliateUsersClicked = true;
       handleGlobalState(tempData);
       navigate('/users');
    }
    const handleShowNumberOfAffiliates = (row : getAffiliates) => {
      setReferrerId(row.uId)
      setIsAffiliateDialogOpen(true);
    }

    const handleclickConfirmDelete = (event : React.MouseEvent<HTMLButtonElement>) =>{
      if(event){
       handleCloseDeletepop();
       deleteAffiliate({
         variables: {
           affiliateId: affiliateDetails?.aId
         }
       })
      }
   }
 
   const handleCloseDeletepop = () =>{
     setDeleteConfirm(false)
     setAffiliateDetails(undefined)
   }
   const handleSetAffiliateStatus = (type: string): string => {
    if(type === "Active" || type === "Direct"){
      return styles.statusActive;
    }else if(type === "Both"){
      return styles.statusVerified;
    }else if (type === "Deactive" || type === "Indirect"){
      return styles.statusDeactive;
    }else {
      return "-";
    }
}
    return (
      <>
        <TableBody className={styles.tablebodyStyle}>
        {list?.getAffiliates?.map((row: getAffiliates, index: number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{root: styles.rowStyle}}
            >
              {/* change the logic based on the status */}
              {row?.aType !== "Indirect" ? <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.firstName} ${ row?.aType !== "Indirect" ?`- ${row?.referralCode}`: "" }`}</span></TableCell>: null}
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.firstName}`}</span></TableCell>
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.lastName}`}</span></TableCell>
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{row?.aOrganization ? row?.aOrganization : '-'}</span></TableCell>
              <TableCell size="small" className={styles.usersEmailCell}>
              <span className={styles.customtableCell}> {row?.emailId} </span>
              </TableCell>
              <TableCell size="small" className={styles.usersStatusCell}>
                <span
                  className={handleSetAffiliateStatus(row?.aStatus)}
                >
                  {row?.aStatus}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.usersStatusCell}>
                <span
                  className={styles.statusVerified}
                >
                  {row?.aType}
                </span>
              </TableCell>              
              {row?.aType !== "Indirect" ? <TableCell size="small" className={styles.usersUserNameCell}><span className={ row?.noOfUsers && row?.noOfUsers > 0 ? styles.affiliateUsersNumber : styles.equalToZero} onClick={() => handleShowNumberOfUsers(row)}>{row?.noOfUsers ? row?.noOfUsers : `-`}</span></TableCell>: null}
              {row?.aType !== "Direct" ? <TableCell size="small" className={styles.usersUserNameCell}>
                <span className={ row?.noOfAffiliates && row?.noOfAffiliates > 0 ? styles.affiliateUsersNumber : styles.equalToZero} onClick={() => handleShowNumberOfAffiliates(row)}>
                  {row?.noOfAffiliates ? `${formatNumberWithCommas(row?.noOfAffiliates)}` : `0`}
                </span>
              </TableCell>: null}
              <TableCell size="small" className={styles.usersUserNameCell}>
                <span>
                  {row?.totalAmount ? `$${formatNumberWithCommas(row?.totalAmount)}` : `$0`}
                </span>
              </TableCell>
              {row?.aType !== "Indirect" ?
                <TableCell size="small" className={styles.usersUserNameCell}>
                <span>
                  {row?.directPayout ? `$${formatNumberWithCommas(row?.directPayout)}` : `$0`}
                </span>
              </TableCell> : null
              }
              {row?.aType !== "Direct" ?
                <TableCell size="small" className={styles.usersUserNameCell}>
                <span>
                  {row?.indirectPayout ? `$${formatNumberWithCommas(row?.indirectPayout)}` : `$0`}
                </span>
              </TableCell> : null
              }
              <TableCell
                size="small"
                className={styles.stickyTableCellForUser}
                >
                <div className={styles.affiliateurl}>
                {(globalState.profile.userRole === roles.MARKETING_USER || globalState.profile.userRole === roles.AFFILIATER_ADMIN)? null :<><div className={styles.userIcondiv}><img src={UserEdit} alt="useredit"  onClick={()=>{handleClickEditAffiliate(row)}}/></div>
                <div className={styles.line}></div></>}
                <div className={row?.aType === "Indirect" ? styles.referalLinkDisable :styles.referalLink}><img src={ReferalIcon} alt="referalLink" onClick={() => handleClickViewReferralUrl(row)}/></div>
                <div className={styles.line}></div>
                <div className={styles.referalLink}><MonetizationOnOutlinedIcon onClick={()=> handleClickViewAffiliateDetails(row)} style={{ color: "#5D75F8", marginRight: '5px' }} /></div>
                </div>
                </TableCell>
            </StyledTableRow>
          );
        })}
        </TableBody>
        <Dialog
        open={openDialogEdit}
        PaperComponent={StyledComponent}
        >
        <AddAffiliate row={affiliateDetails} handleCloseDialog={handleCloseEditAffiliate} isEdit={true} setCurrentPage= {setCurrentPage} setDeleteConfirm={setDeleteConfirm} setColumnTypes={setColumnTypes} setSortType={setSortType}/>
        </Dialog>
        <Dialog
        open={isAffiliatesDialogOpen}
        PaperComponent={StyledComponentForFitContent}
        >
        <DisplayAffiliate setIsAffiliateDialogOpen = {setIsAffiliateDialogOpen} referrerId = {referrerId}
        />
        </Dialog>
        <Dialog
        open={openReferralUrlPopup}
        PaperComponent={StyledComponent}
        >
          <ReferralUrl referralDetail = {affiliateDetails} handleCloseReferralDialog = {handleCloseReferralDialog}/>
        </Dialog>
        <Dialog open={deleteConfirm} PaperComponent={StyledComponent}>
          <PublishPopup handleAllow={handleclickConfirmDelete} handleClose={handleCloseDeletepop} title={"Delete Affiliate?"} subTitle={"Removing this item could result in the loss of data"} affiliate={true}/>
        </Dialog>
      </>
    );
}

export function AffiliatePopupUsersTableBody(props :any){
  const {list, isSelected} = props;
  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
      {list?.getAffiliates?.map((row: getAffiliates, index: number) => {
        const isItemSelected = isSelected(index);
        return (
          <StyledTableRow
            aria-checked={isItemSelected}
            tabIndex={-1}
            key={index}
            classes={{root: styles.rowStyle}}
          >
            <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.userFullName}`}</span></TableCell>
            <TableCell size="small" className={styles.usersEmailCell}>
            <span className={styles.customtableCell}> {row?.emailId} </span>
            </TableCell>
            <TableCell size="small" className={styles.usersStatusCell}>
              <span
                className={styles.statusVerified}
              >
                {row?.aType}
              </span>
            </TableCell>
          </StyledTableRow>
        );
      })}
      </TableBody>
    </>
  );
}

export function AffiliateTransactionsUsersTableBody(props :any){
  const {list, isSelected, setCurrentPage,setColumnTypes,setSortType,affiliateDetailsView,setAffiliateDetailsView} = props;
  const {ReferalIcon,UserEdit} = images
  const [affiliateDetails, setAffiliateDetails] = useState<affiliateViewById>()
  const StyledComponent = CustomPaperComponent();
  const [openDialogEdit, setOpenDialogEdit] = useState<boolean>(false);
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [openReferralUrlPopup, setOpenReferralUrlPopup] = useState<boolean>(false)
 const [deleteConfirm, setDeleteConfirm] = useState<boolean>(false)
  const {success,error} = ToasterWithMessage();
  const navigate = useNavigate();

 const handleSetAffiliateTransactionsStatus = (type: string): string => {
  if(type === "Transfer_Success" || type === "Settlement_Success" || type === "Settlement_Inprogress"){
    return styles.statusActive;
  }else if (type === "Transfer_Failed"){
    return styles.statusDeactive;
  }else {
    return "-";
  }
}
  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
      {list?.affiliateTransactions?.map((row: getAffiliateTransactionsType, index: number) => {
        const isItemSelected = isSelected(index);
        return (
          <StyledTableRow
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={index}
          classes={{root: styles.rowStyle}}
        >
            {/* change the logic based on the status */}
            {/* {row?.aType !== "Indirect" ? <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.firstName} ${ row?.aType !== "Indirect" ?`- ${row?.referralCode}`: "" }`}</span></TableCell>: null} */}
            <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.ut_transaction_id}`}</span></TableCell>
            <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`$${formatNumberWithCommas(row?.ut_transaction_amount)}`}</span></TableCell>
            <TableCell size="small" className={styles.usersEmailCell}>
            <span className={styles.customtableCell}>{moment(row?.ut_transaction_date)
                              .tz("America/Chicago")
                              .format('ddd DD MMM, hh:mm A z')}</span>
            </TableCell>
            <TableCell size="small" className={styles.usersStatusCell}>
              <span
                className={styles.statusVerified}
              >
                {row?.ut_type}
              </span>
            </TableCell>
            <TableCell size="small" className={styles.usersStatusCell}>
              <span
                className={handleSetAffiliateTransactionsStatus(row?.ut_transaction_status)}
              >
                {row?.ut_transaction_status}
              </span>
            </TableCell>  
            <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{row?.ut_invoice_number ?? '-'}</span></TableCell>
            <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{row?.ut_payout_status === null ? '-' : row?.ut_payout_status === 'in_transit' ? 'In process' : String(row?.ut_payout_status)?.charAt(0)?.toLocaleUpperCase() + String(row?.ut_payout_status)?.slice(1)}</span></TableCell>
            {/* {row?.aType !== "Direct" ? <TableCell size="small" className={styles.usersUserNameCell}>
              <span>
                {row?.noOfAffiliates ? `${row?.noOfAffiliates}` : `0`}
              </span>
            </TableCell>: null} */}
            {/* <TableCell size="small" className={styles.usersUserNameCell}>
              <span>
                {row?.totalAmount ? `$${(row?.totalAmount).toFixed(2)}` : `$0`}
              </span>
            </TableCell> */}
            {/* {row?.aType !== "Indirect" ?
              <TableCell size="small" className={styles.usersUserNameCell}>
              <span>
                {row?.directPayout ? `$${(row?.directPayout).toFixed(2)}` : `$0`}
              </span>
            </TableCell> : null
            }
            {row?.aType !== "Direct" ?
              <TableCell size="small" className={styles.usersUserNameCell}>
              <span>
                {row?.indirectPayout ? `$${(row?.indirectPayout).toFixed(2)}` : `$0`}
              </span>
            </TableCell> : null
            } */}
            {/* <TableCell
              size="small"
              className={styles.stickyTableCellForUser}
              >
              <div className={styles.affiliateurl}>
              {globalState.profile.userRole === "marketing_user"? null :<><div className={styles.userIcondiv}><img src={UserEdit} alt="useredit"  onClick={()=>{handleClickEditAffiliate(row)}}/></div>
              <div className={styles.line}></div></>}
              <div className={row?.aType === "Indirect" ? styles.referalLinkDisable :styles.referalLink}><img src={ReferalIcon} alt="referalLink" onClick={() => handleClickViewReferralUrl(row)}/></div>
              <div className={styles.line}></div>
              <div className={row?.aType === "Indirect" ? styles.referalLinkDisable :styles.referalLink}><MonetizationOnOutlinedIcon onClick={()=> handleClickViewAffiliateDetails(row)} style={{ color: "#5D75F8", marginRight: '5px' }} /></div>
              </div>
              </TableCell> */}
          </StyledTableRow>
        );
      })}
      </TableBody>
      {/* <Dialog
      open={openDialogEdit}
      PaperComponent={StyledComponent}
      >
      <AddAffiliate row={affiliateDetails} handleCloseDialog={handleCloseEditAffiliate} isEdit={true} setCurrentPage= {setCurrentPage} setDeleteConfirm={setDeleteConfirm} setColumnTypes={setColumnTypes} setSortType={setSortType}/>
      </Dialog> */}
      {/* <Dialog
      open={openReferralUrlPopup}
      PaperComponent={StyledComponent}
      >
        <ReferralUrl referralDetail = {affiliateDetails} handleCloseReferralDialog = {handleCloseReferralDialog}/>
      </Dialog> */}
      {/* <Dialog open={deleteConfirm} PaperComponent={StyledComponent}>
        <PublishPopup handleAllow={handleclickConfirmDelete} handleClose={handleCloseDeletepop} title={"Delete Affiliate?"} subTitle={"Removing this item could result in the loss of data"} affiliate={true}/>
      </Dialog> */}
    </>
  );
}
interface approximateTpArray  {
  e_date: string
  e_name: string
  tp_id: string
  tp_row:string
  tp_seat_no: string,
  tp_section: string
  tp_status:string
}
interface errorRowType {
  approximateTpIdArray: [approximateTpArray];
  errorMessageId:string|null;
  eventDate: string | null;
  eventName: string | null;
  reason: string | null;
  row: string | null;
  seatNo: string | null;
  section: string | null;
  ticketPlacementId: string | null;
  userId: string | null;
  userName: string | null;
  userEmail: string | null;
  originalEmail : string | null;
  ticketsError: boolean;
  occurringDate: string;
  ticketStatus: string |null;
  ticketListPrice:string|null;
  eventAddress:string|null;
}

export function AddTicketsErrorTableBody(props: any){
  const {
    list,
    isSelected
  } = props;
  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const navigate = useNavigate();
  const {success,error} = ToasterWithMessage();

  const [triggerError] = useMutation(TRIGGER_ERROR_TICKETS,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data?.triggerErrorTickets?.message){
      success("Ticket Verified successfully");
      }
      const tempState = {...globalState};
      tempState.trigger.addTicketError = true;
      handleGlobalState(tempState);
    },
    onError: () => {
      error("Something went Wrong!");
    }
  });
  
  const handleClickAddTicketError = (errRow: errorRowType) => {
    let approximateTpArray: any = [];
    const tempState = { ...globalState };
    if(globalState.errorStatus.addTicket === 'Failed'){
    if (errRow?.ticketsError) {
      tempState.error.text = "Error-filter";
      tempState.error.errorClicked = true;
      if(errRow?.ticketPlacementId){
        tempState.error.ticketPlacementId = [errRow?.ticketPlacementId];
        tempState.error.status = errRow?.ticketStatus
      }else if(errRow?.approximateTpIdArray?.length >0){
      errRow?.approximateTpIdArray.map((tp_id: approximateTpArray) => {
        return approximateTpArray.push(tp_id?.tp_id);
      });
      tempState.error.status = "ToBeVerified"
      tempState.error.approximateTpArray = approximateTpArray;
    }else {
      tempState.error.ticketPlacementId =  []
      tempState.error.status = "ToBeVerified"
    }
      tempState.error.errorSearchCancel = !globalState.error.errorSearchCancel;
      
      handleGlobalState(tempState);
      navigate("/tickets");
    } else {
      tempState.globalSearch.searchtext = errRow?.userEmail ? errRow?.userEmail :''
      tempState.error.userError = true;
      handleGlobalState(tempState)
      navigate("/users");
    }}else if(globalState.errorStatus.addTicket === 'Success'){
      tempState.error.text = "Success-filter";
      tempState.error.errorClicked = true;
      if(errRow?.ticketPlacementId){
        tempState.error.ticketPlacementId = [errRow?.ticketPlacementId];
        tempState.error.status = errRow?.ticketStatus
      }
      handleGlobalState(tempState);
      navigate("/tickets");
    }

  };
  const handleClickAddTicketErrorTrigger = (errRow: errorRowType) => {
    triggerError({
      variables:{
        input:{
          action: "Add",
          section:errRow?.section,
          row: errRow?.row,
          seatNo: errRow?.seatNo,
          eventDate: errRow?.eventDate,
          eventName: errRow?.eventName,
          errorMessageId: errRow?.errorMessageId,
          eventAddress: errRow?.eventAddress
        }
      }
    })
  };
  return (
    <>
      <TableBody className={styles.addTicketErrorTablebodyStyle}>
        {list?.getTicketsMail?.ticketsData?.map((errorRow: errorRowType,index:number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{ root: styles.rowStyle }}
            >
              <TableCell size="small" className={styles.eventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.eventName ? errorRow?.eventName : "-"}
                </span>
              </TableCell>
              <TableCell size="small" className={globalState.errorStatus.addTicket === "Failed" ?styles.eventDateCell : styles.eventSuccessDateCell}>
                {globalState.errorStatus.addTicket === "Failed" ? (
                  <span className={styles.customaddtableCell}>
                    {errorRow?.eventDate ? errorRow?.eventDate : "-"}
                  </span>
                ) : errorRow?.eventDate ? (
                  <>
                    <div>{checking(errorRow?.eventDate).date}</div>
                    <div>{checking(errorRow?.eventDate).time}</div>
                  </>
                ) : (
                  "-"
                )}
              </TableCell>
              <TableCell size="small" className={styles.addErrorAddressCell}>
                  <span className={styles.venueStyle}>
                    {errorRow?.eventAddress ? errorRow?.eventAddress : "-"}
                  </span>
                </TableCell>
              {globalState.errorStatus.addTicket === "Failed" && (
                <TableCell size="small" className={styles.errorReasonCell}>
                  <span className={styles.errorReason}>
                    {errorRow?.reason ? errorRow?.reason?.includes("User Provided Details are Incorrect") ? "Logitix records are unable to match any user ticket details.":errorRow?.reason : "-"}
                  </span>
                </TableCell>
              )}
              <TableCell size="small" className={styles.addErrorRaisedDate}>
                {errorRow?.occurringDate ? (
                  <span className={styles.customtableCell}>
                    <div className={styles.stripeErrorEventDateCell}>
                      <div>{checking(errorRow?.occurringDate).date}</div>
                      <div>{checking(errorRow?.occurringDate).time}</div>
                    </div>
                  </span>
                ) : (
                  <span> -</span>
                )}
              </TableCell>
              <TableCell size="small" className={styles.errorTicketPlacement}>
                <TicketPlacements
                  tickets={errorRow}
                  tableTitle={"addTicketError"}
                />
              </TableCell>
              {globalState.errorStatus.addTicket === "Success" && (
              <TableCell size="small" className={styles.errorReasonCell}>
              <span className={styles.errorReason} style = {{color: errorRow?.reason ? 'orange' : 'black'}}>
                  {errorRow?.reason ? errorRow?.reason : "-"}
                </span>
              </TableCell>
              )}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.userNameSpanStyle}>
                  {errorRow?.userName ? errorRow?.userName : "-"}
                </span>
              </TableCell>}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                <TableCell size="small" className={styles.errorUsersEmailCell}>
                  <span className={styles.customtableCell}>
                    {errorRow?.originalEmail ? errorRow?.originalEmail : errorRow?.userEmail ? errorRow?.userEmail : '-'}
                  </span>
                  <span className={styles.customtableCell}>
                    {errorRow?.originalEmail ? ' [deleted user]' : ''}
                  </span>
                </TableCell>}
              <TableCell size="small" className={styles.stickyTableCell}>
              <div style={{display: 'flex',justifyContent:'space-evenly',width:'100%'}}>
                <div
                  className={styles.addErrorViewBtn}
                >
                  <Button
                    // sx={{ color: "#b9bdc6" }}
                    classes={{ root: styles.separateStyle }}
                    fullWidth
                    disabled={Number(errorRow?.approximateTpIdArray.length) === 0 && errorRow?.ticketPlacementId === null}
                    onClick={() => {
                      handleClickAddTicketError(errorRow);
                    }}
                    >
                    View
                  </Button>
                </div>
                {globalState.errorStatus.addTicket === "Failed"&& <div
                  className={styles.addErrorViewBtn}
                >
                  <Button
                    classes={{ root: styles.separateStyle }}
                    disabled ={!errorRow?.reason?.includes('Event Name is Incorrect')}
                    fullWidth
                    onClick={() => {
                      handleClickAddTicketErrorTrigger(errorRow);
                    }}
                  >
                    Reverify
                  </Button>
                </div>}
                </div>
              </TableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </>
  );
}



export function SoldTicketsErrorTableBody(props: any){
  const {
    list,
    isSelected
  } = props;

  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const navigate = useNavigate();
  const {success,error}=ToasterWithMessage();

  // const [triggerError] = useMutation(TRIGGER_ERROR_TICKETS,{
  //   fetchPolicy: "no-cache",
  //   onCompleted: (data) => {
  //     if(data?.triggerErrorTickets.message){
  //     success("Ticket sold successfully");
  //     }
  //     const tempState = {...globalState};
  //     tempState.trigger.soldTicketError = true;
  //     handleGlobalState(tempState);
  //   },
  //   onError: () => {
  //     error("Something went Wrong!");
  //   }
  // });
  const handleClickSoldTicketError = (errRow: errorRowType) => {
    let approximateTpArray: any = [];
    const tempValue = { ...globalState };
    if(globalState.errorStatus.soldTicket === 'Failed'){
    if (errRow?.ticketsError) {
      tempValue.error.text = "Error-filter";
      tempValue.error.errorClicked = true;
      if(errRow?.ticketPlacementId){
        tempValue.error.ticketPlacementId = [errRow?.ticketPlacementId];
        tempValue.error.status = errRow?.ticketStatus
      }else if(errRow?.approximateTpIdArray?.length >0){
      errRow?.approximateTpIdArray?.map((tp_id: approximateTpArray) => {
        return approximateTpArray.push(tp_id?.tp_id);
      });
      tempValue.error.status = "List"
      tempValue.error.approximateTpArray = approximateTpArray;
    }else {
      tempValue.error.ticketPlacementId =  []
      tempValue.error.status = "List"
    }
      tempValue.error.errorSearchCancel = !globalState.error.errorSearchCancel;
      handleGlobalState(tempValue);
      navigate("/tickets");
    } else {
      tempValue.globalSearch.searchtext = errRow?.userEmail ? errRow?.userEmail :''
      tempValue.error.userError = true;
      handleGlobalState(tempValue)
      navigate("/users");
    }}
    else if(globalState.errorStatus.soldTicket === 'Success'){
      tempValue.error.text = "Success-filter";
      tempValue.error.errorClicked = true;
      if(errRow?.ticketPlacementId){
        tempValue.error.ticketPlacementId = [errRow?.ticketPlacementId];
        tempValue.error.status = errRow?.ticketStatus
      }
      handleGlobalState(tempValue);
      navigate("/tickets");
    }
  };
  // const handleClickSoldTicketErrorTrigger = (errRow: errorRowType) => {
  //   triggerError({
  //     variables:{
  //       input:{
  //         action: "Sold",
  //         section:errRow?.section,
  //         row: errRow?.row,
  //         seatNo: errRow?.seatNo,
  //         eventDate: errRow?.eventDate,
  //         eventName: errRow?.eventName,
  //         errorMessageId: errRow?.errorMessageId,
  //         eventAddress: errRow?.eventAddress
  //       }
  //     }
  //   })
  // };
  return (
    <>
      <TableBody className={styles.soldTicketErrorTablebodyStyle}>
        {list?.getTicketsMail?.ticketsData?.map((errorRow: errorRowType,index:number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{ root: styles.rowStyle }}
            >
              <TableCell size="small" className={styles.soldErrorEventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.eventName ? errorRow?.eventName : "-"}
                </span>
              </TableCell>
              <TableCell size="small" className={globalState.errorStatus.soldTicket === "Failed" ? styles.soldErrorEventDateCell : styles.soldsuccessReasonCell}>
                {globalState.errorStatus.soldTicket === "Failed" ? (
                  <span className={styles.customsoldtableCell}>
                    {errorRow?.eventDate ? errorRow?.eventDate : "-"}
                  </span>
                ) : errorRow?.eventDate ? (
                  <div>
                    <div>{checking(errorRow?.eventDate).date}</div>
                    <div>{checking(errorRow?.eventDate).time}</div>
                  </div>
                ) : (
                  "-"
                )}
                </TableCell>
                <TableCell size="small" className={styles.soldErrorAddressCell}>
                  <span className={styles.soldvenueStyle}>
                    {errorRow?.eventAddress ? errorRow?.eventAddress : "-"}
                  </span>
                </TableCell>
              {globalState.errorStatus.soldTicket === "Failed" && (
                <TableCell size="small" className={styles.soldErrorReasonCell}>
                  <span className={styles.soldErrorReason}>
                  {errorRow?.reason ? errorRow?.reason?.includes("User Provided Details are Incorrect") ? "Logitix records are unable to match any user ticket details.":errorRow?.reason : "-"}
                  </span>
                </TableCell>
              )}
              <TableCell size="small" className={styles.soldErrorRaisedDate}>
                {errorRow?.occurringDate ? (
                  <span className={styles.customtableCell}>
                    <div className={styles.stripeErrorEventDateCell}>
                      <div>{checking(errorRow?.occurringDate).date}</div>
                      <div>{checking(errorRow?.occurringDate).time}</div>
                    </div>
                  </span>
                ) : (
                  <span> -</span>
                )}
              </TableCell>
              <TableCell
                size="small"
                className={styles.soldErrorTicketPlacement}
              >
                <TicketPlacements
                  tickets={errorRow}
                  tableTitle={"soldTicketError"}
                />
              </TableCell>
              {globalState.errorStatus.soldTicket === "Success" && (
                <TableCell size="small" className={styles.soldErrorReasonCell}>
                  <span className={styles.soldErrorReason} style={{color: errorRow?.reason ? 'orange' : 'black'}}>
                  {errorRow?.reason ? errorRow?.reason : "-"}
                  </span>
                </TableCell>
              )}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.soldErrorUserNameSpanStyle}>
                  {errorRow?.userName ? errorRow?.userName : "-"}
                </span>
              </TableCell>}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                <TableCell
                  size="small"
                  className={styles.soldErrorUsersEmailCell}
                >
                  <span className={styles.customtableCell}>
                    {errorRow?.originalEmail ? errorRow?.originalEmail : errorRow?.userEmail ? errorRow?.userEmail : '-'}
                  </span>
                  <span className={styles.customtableCell}>
                    {errorRow?.originalEmail ? ' [deleted user]' : ''}
                  </span>
                </TableCell>}
              <TableCell size="small" className={styles.stickyTableCell}>
              <div style={{display: 'flex',justifyContent:'space-evenly',width:'100%'}}>
                <div
                  className={styles.soldErrorViewBtn}
                >
                  <Button
                    // sx={{ color: "#b9bdc6" }}
                    classes={{ root: styles.separateStyle }}
                    disabled={Number(errorRow?.approximateTpIdArray?.length) === 0 && errorRow?.ticketPlacementId === null}
                    fullWidth 
                    onClick={() => {
                      handleClickSoldTicketError(errorRow);
                    }}
                    // onClick={(e) => handlepublish(true, row)}
                  >
                    View
                  </Button>
                </div>
                {/* {globalState.errorStatus.soldTicket === "Failed"&& <div
                  className={styles.addErrorViewBtn}
                >
                  <Button
                    classes={{ root: styles.separateStyle }}
                    disabled ={!errorRow?.reason?.includes('Event Name is Incorrect')}
                    fullWidth
                    onClick={() => {
                      handleClickSoldTicketErrorTrigger(errorRow);
                    }}
                  >
                    Resell
                  </Button>
                </div>} */}
                </div>
              </TableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </>
  );
}
export function PublishTicketsErrorTableBody(props: any){
  const {
    list,
    isSelected
  } = props;

  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const navigate = useNavigate();
  const {success,error}=ToasterWithMessage();
  const [triggerError] = useMutation(TRIGGER_ERROR_TICKETS,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data?.triggerErrorTickets?.message){
      success("Ticket published successfully");
      }
      const tempState = {...globalState};
      tempState.trigger.publishTicketError = true;
      handleGlobalState(tempState);
    },
    onError: () => {
      error("Something went Wrong!");
    }
  });
  const handleClickPublishTicketError = (errRow: errorRowType) => {
    let approximateTpArray: any = [];
    const tempValue = { ...globalState };
    if(globalState.errorStatus.publishTicket === 'Failed'){
    if (errRow?.ticketsError) {
      tempValue.error.text = "Error-filter";
      tempValue.error.errorClicked = true;
      if(errRow?.ticketPlacementId){
        tempValue.error.ticketPlacementId = [errRow?.ticketPlacementId];
        tempValue.error.status = errRow?.ticketStatus
      }else if(errRow?.approximateTpIdArray?.length >0){
      errRow?.approximateTpIdArray?.map((tp_id: approximateTpArray) => {
        return approximateTpArray.push(tp_id?.tp_id);
      });
      tempValue.error.status = errRow?.approximateTpIdArray?.[0].tp_status
      tempValue.error.approximateTpArray = approximateTpArray;
    }else {
      tempValue.error.ticketPlacementId =  []
      tempValue.error.status = "List"
    }
      tempValue.error.errorSearchCancel = !globalState.error.errorSearchCancel;
      handleGlobalState(tempValue);
      navigate("/tickets");
    } else {
      tempValue.globalSearch.searchtext = errRow?.userEmail ? errRow?.userEmail :''
      tempValue.error.userError = true;
      handleGlobalState(tempValue)
      navigate("/users");
    }}
    else if(globalState.errorStatus.publishTicket === 'Success'){
      tempValue.error.text = "Success-filter";
      tempValue.error.errorClicked = true;
      if(errRow.ticketPlacementId){
        tempValue.error.ticketPlacementId = [errRow?.ticketPlacementId];
        tempValue.error.status = errRow?.ticketStatus
      }
      handleGlobalState(tempValue);
      navigate("/tickets");
    }
  };
  const handleClickPublishTicketErrorTrigger = (errRow: errorRowType) => {
    triggerError({
      variables:{
        input:{
          action: "Publish",
          section:errRow?.section,
          row: errRow?.row,
          seatNo: errRow?.seatNo,
          eventDate: errRow?.eventDate,
          eventName: errRow?.eventName,
          errorMessageId: errRow?.errorMessageId,
          eventAddress: errRow?.eventAddress
        }
      }
    })
  };
  return (
    <>
      <TableBody className={styles.publishTicketErrorTablebodyStyle}>
        {list?.getTicketsMail?.ticketsData?.map((errorRow: errorRowType,index:number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{ root: styles.rowStyle }}
            >
              <TableCell size="small" className={styles.publishErrorEventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.eventName ? errorRow?.eventName : "-"}
                </span>
              </TableCell>
              <TableCell size="small" className={globalState.errorStatus.publishTicket === "Failed" ? styles.publishErrorEventDateCell : styles.publishsuccessReasonCell}>
                {globalState.errorStatus.publishTicket === "Failed" ? (
                  <span className={styles.custompublishtableCell}>
                    {errorRow?.eventDate ? errorRow?.eventDate : "-"}
                  </span>
                ) : errorRow?.eventDate ? (
                  <div>
                    <div>{checking(errorRow?.eventDate).date}</div>
                    <div>{checking(errorRow?.eventDate).time}</div>
                  </div>
                ) : (
                  "-"
                )}
                </TableCell>
                <TableCell size="small" className={styles.publishErrorAddressCell}>
                  <span className={styles.publishvenueStyle}>
                    {errorRow?.eventAddress ? errorRow?.eventAddress : "-"}
                  </span>
                </TableCell>
              {globalState.errorStatus.publishTicket === "Failed" && (
                <TableCell size="small" className={styles.publishErrorReasonCell}>
                  <span className={styles.publishErrorReason}>
                  {errorRow?.reason ? errorRow?.reason?.includes("User Provided Details are Incorrect") ? "Logitix records are unable to match any user ticket details.":errorRow?.reason : "-"}
                  </span>
                </TableCell>
              )}
              <TableCell size="small" className={styles.publishErrorRaisedDate}>
                {errorRow?.occurringDate ? (
                  <span className={styles.customtableCell}>
                    <div className={styles.stripeErrorEventDateCell}>
                      <div>{checking(errorRow?.occurringDate).date}</div>
                      <div>{checking(errorRow?.occurringDate).time}</div>
                    </div>
                  </span>
                ) : (
                  <span> -</span>
                )}
              </TableCell>
              <TableCell
                size="small"
                className={styles.publishErrorTicketPlacement}
              >
                <TicketPlacements
                  tickets={errorRow}
                  tableTitle={"publishTicketError"}
                />
              </TableCell>
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.publishErrorUserNameSpanStyle}>
                  {errorRow?.ticketListPrice ? `$${errorRow?.ticketListPrice}` : "-"}
                </span>
              </TableCell>
              {globalState.errorStatus.publishTicket === "Success" && (
                <TableCell size="small" className={styles.publishErrorReasonCell}>
                  <span className={styles.publishErrorReason} style={{color: errorRow?.reason ? 'orange' : 'black'}}>
                  {errorRow?.reason ? errorRow?.reason : "-"}
                  </span>
                </TableCell>
              )}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && 
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.publishErrorUserNameSpanStyle}>
                  {errorRow?.userName ? errorRow?.userName : "-"}
                </span>
              </TableCell>}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                <TableCell
                  size="small"
                  className={styles.publishErrorUsersEmailCell}
                >
                  <span className={styles.customtableCell}>
                    {errorRow?.originalEmail ? errorRow?.originalEmail : errorRow?.userEmail ? errorRow?.userEmail : '-'}
                  </span>
                  <span className={styles.customtableCell}>
                    {errorRow?.originalEmail ? ' [deleted user]' : ''}
                  </span>
                </TableCell>}
              <TableCell size="small" className={styles.stickyTableCell}>
              <div style={{display: 'flex',justifyContent:'space-evenly',width:'100%'}}>
                <div
                  className={styles.publishErrorViewBtn}
                >
                  <Button
                    // sx={{ color: "#b9bdc6" }}
                    classes={{ root: styles.separateStyle }}
                    fullWidth
                    disabled={Number(errorRow?.approximateTpIdArray?.length) === 0 && errorRow?.ticketPlacementId === null}
                    onClick={() => {
                      handleClickPublishTicketError(errorRow);
                    }}
                  >
                    View
                  </Button>
                </div>
                {globalState.errorStatus.publishTicket === "Failed"&& <div
                  className={styles.addErrorViewBtn}
                >
                  <Button
                    classes={{ root: styles.separateStyle }}
                    disabled ={!errorRow?.reason?.includes('Event Name is Incorrect')}
                    fullWidth
                    onClick={() => {
                      handleClickPublishTicketErrorTrigger(errorRow);
                    }}
                  >
                    Republish
                  </Button>
                </div>}
                </div>
              </TableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </>
  );
}

interface stripeErrorType{
    se_id: string,
    email_id: string,
    pt_id: string,
    se_date: string,
    se_reason: string,
    u_id: string,
    se_created_at: string,
    se_updated_at: string,
    payment_transaction: {
        pt_id: string,
        pt_invoice_number: null,
        pt_quick_cut: number,
        pt_transaction_amount: number,
        pt_transaction_date: string,
        pt_transaction_id: string | null,
        pt_transaction_status: string,
        pt_created_at: string,
        pt_updated_at: string,
        ticket_placement: [
            {
                tp_id: string,
                tp_row: string,
                tp_seat_no: string,
                tp_section: string,
                tp_status: string,
                ticket: {
                    e_id: string,
                    event: {
                        e_id: string,
                        e_name: string,
                        e_date: string,
                        e_address: string,
                        e_cdt_date: string
                    }
                }
            }
        ]
    },
    user: {
        u_id: string,
        u_first_name: string,
        u_last_name: string,
        u_email_id: string,
        u_original_email: string | null,
        u_full_name: string,
        u_avatar_url: string | null
    }
}


export function StripePaymentsErrorTableBody(props:any){
const {
  list,
  isSelected
} = props;
  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
        {list?.stripe_errors?.map((stripeError: stripeErrorType,index:number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
            aria-checked={isItemSelected}
            tabIndex={-1}
            key={index}
            classes={{root: styles.rowStyle}}
          >
            <TableCell size="small" className={styles.stripeTransactionIdCell}>
              <span className={styles.customtableCell}>
                {stripeError?.payment_transaction?.pt_id ? stripeError?.payment_transaction?.pt_id : '-'}
              </span>
            </TableCell>
            <TableCell size="small" className={styles.errorUsersNameCell}>
              <span className={styles.stripeErrorUserNameSpanStyle}>
                {stripeError?.user?.u_full_name ? stripeError?.user?.u_full_name : '-'}
              </span>
            </TableCell>
              <TableCell size="small" className={styles.stripePaymentErrorUserEmail}>
                <span className={styles.customtableCell}>
                  {stripeError?.user?.u_original_email ? stripeError?.user?.u_original_email : stripeError?.user?.u_email_id ? stripeError?.user?.u_email_id : '-'}
                </span>
                <span className={styles.customtableCell}>
                  {stripeError?.user?.u_original_email ? ' [deleted user]' : ''}
                </span>
              </TableCell>
            <TableCell size="small" className={styles.stripeErrorReason}>
              <span className={styles.stripeErrorReason}>
                {stripeError?.se_reason ? stripeError?.se_reason.toLowerCase().includes("insufficient")?`You have insufficient available funds in your Stripe account.`:stripeError?.se_reason : '-'}
              </span>
            </TableCell>
            <TableCell size="small" className={styles.stripeErrorRaisedDate}>
              <span className={styles.customtableCell}>
                {/* {stripeError?.se_date ? stripeError?.se_date : '-'} */}
                <div className={styles.solddateStyle}>
                      <div>{checking(stripeError?.se_date).date}</div>
                      <div>{checking(stripeError?.se_date).time}</div>
                    </div>
              </span>
            </TableCell>
            <TableCell size="small" className={styles.stripeErrorEventNameCell}>
              <span className={styles.customtableCell}>
                {
                stripeError?.payment_transaction?.ticket_placement?.[0]?.ticket?.event?.e_name 
                ?  stripeError?.payment_transaction?.ticket_placement?.[0]?.ticket?.event?.e_name
                : '-'}
              </span>
            </TableCell>
            <TableCell size="small" className={styles.stripeErrorEventDateCell}>
                    <div className={styles.solddateStyle}>
                      <div>{checking(stripeError?.payment_transaction?.ticket_placement?.[0]?.ticket?.event?.e_date).date}</div>
                      <div>{checking(stripeError?.payment_transaction?.ticket_placement?.[0]?.ticket?.event?.e_date).time}</div>
                    </div>
            </TableCell>
            <TableCell
              size="small"
              className={styles.errorTicketPlacement}
            >
                <TicketPlacements 
                  tickets={stripeError} 
                  tableTitle = {"stripePaymentError"}/>
            </TableCell>
          </StyledTableRow>
          );
        })}
      </TableBody>
    </>
  );
}


interface stripepayoutErrorType {
  pe_account_id: string
  pe_amount: number
  pe_created_at: string
  pe_currency: string
  pe_payout_id: string
  pe_reason: string
  pe_status: string
  user: {
    u_email_id: string
    u_original_email: string | null
    u_id: string
    u_first_name: string
    u_last_name: string
  };
}
interface stripepayoutSuccessType {
  ps_account_id: string
  ps_amount: number
  ps_created_at: string
  ps_currency: string
  ps_payout_id: string
  user: {
    u_email_id: string
    u_original_email: string | null
    u_id: string
    u_first_name: string
    u_last_name: string
  };
}
export function StripePayoutErrorTableBody(props:any){
  const {
    list,
    isSelected
  } = props;
    return (
      <>
        <TableBody className={styles.tablebodyStyle}>
          {
          list?.payout_errors?(
          list?.payout_errors?.map((stripeError: stripepayoutErrorType,index:number) => {
            const isItemSelected = isSelected(index);
            return (
              <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{root: styles.rowStyle}}
            >
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.stripeErrorUserNameSpanStyle}>
                  {stripeError?.user?.u_first_name ? stripeError?.user?.u_first_name : '-'}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.stripeErrorUserNameSpanStyle}>
                  {stripeError?.user?.u_last_name ? stripeError?.user?.u_last_name : '-'}
                </span>
              </TableCell>
                <TableCell size="small" className={styles.stripeErrorUserEmail}>
                  <span className={styles.customtableCell}>
                    {stripeError?.user?.u_original_email ? stripeError?.user?.u_original_email : stripeError?.user?.u_email_id ? stripeError?.user?.u_email_id : '-'}
                  </span>
                  <span className={styles.customtableCell}>
                    {stripeError?.user?.u_original_email ? ' [deleted user]' : ''}
                  </span>
                </TableCell>
              <TableCell size="small" className={styles.stripeErrorReason}>
                <span className={styles.errorReason}>
                  {stripeError?.pe_reason ? stripeError?.pe_reason : '-'}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.stripeErrorRaisedDate}>
                <span className={styles.customtableCell}>
                  <div className={styles.solddateStyle}>
                        <div>{checking(stripeError?.pe_created_at).date}</div>
                        <div>{checking(stripeError?.pe_created_at).time}</div>
                      </div>
                </span>
              </TableCell>
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.customtableCell}>
                  {`${stripeError?.pe_amount}`? `$${(stripeError?.pe_amount)/100}`: `"-"`}
                </span>
              </TableCell>

              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.stripeErrorUserNameSpanStyle}>
                  {stripeError?.pe_status ? formatUnderScore(stripeError?.pe_status) : '-'}
                </span>
              </TableCell>
              
            </StyledTableRow>
            );
          })
        ):(
          list?.payouts_succeed?.map((stripeSuccess: stripepayoutSuccessType,index:number) => {
            const isItemSelected = isSelected(index);
            return (
              <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{root: styles.rowStyle}}
            >
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.stripeErrorUserNameSpanStyle}>
                  {stripeSuccess?.user?.u_first_name ? stripeSuccess?.user?.u_first_name : '-'}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.errorUsersNameCell}>
                <span className={styles.stripeErrorUserNameSpanStyle}>
                  {stripeSuccess?.user?.u_last_name ? stripeSuccess?.user?.u_last_name : '-'}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.stripeErrorUserEmail}>
              <span className={styles.customtableCell}>
                  {stripeSuccess?.user?.u_original_email ? stripeSuccess?.user?.u_original_email : stripeSuccess?.user?.u_email_id ? stripeSuccess?.user?.u_email_id : '-'}
                </span>
                <span className={styles.customtableCell}>
                  {stripeSuccess?.user?.u_original_email ? ' [deleted user]' : ''}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.stripeErrorRaisedDate}>
                <span className={styles.customtableCell}>
                  <div className={styles.solddateStyle}>
                        <div>{checking(stripeSuccess?.ps_created_at).date}</div>
                        <div>{checking(stripeSuccess?.ps_created_at).time}</div>
                      </div>
                </span>
              </TableCell>
              <TableCell size="small" className={styles.stripeErrorEventNameCell}>
                <span className={styles.customtableCell}>
                  {`${stripeSuccess?.ps_amount}`? `$${formatNumberWithCommas((stripeSuccess?.ps_amount)/100)}`: `"-"`}
                </span>
              </TableCell> 
            </StyledTableRow>
            );
          })
        )}
        </TableBody>
      </>
    );
  }

interface ScrapeErrorType {
  ee_id: string
  ee_name:string
  ee_reason: string
  ee_updated_at: string
  ee_description: {
    error: string
  },
  ee_created_at: string
}

export function ScrapeEventErrorTableBody(props:any){
  const {
    list,
    isSelected
  } = props;
    return (
      <>
         <TableBody className={styles.tablebodyStyle}>
        {list?.event_errors.map((scrapeError: ScrapeErrorType,index:number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
            aria-checked={isItemSelected}
            tabIndex={-1}
            key={index}
            classes={{root: styles.rowStyle}}
          >
            <TableCell size="small" className={styles.stripeTransactionIdCell}>
              <span className={styles.customtableCell}>
                {scrapeError?.ee_name ? scrapeError?.ee_name : '-'}
              </span>
            </TableCell>
            <TableCell size="small" className={styles.errorUsersNameCell}>
              <span className={styles.scrapeErrorUserNameSpanStyle}>
                {scrapeError?.ee_reason ? scrapeError?.ee_reason : '-'}
              </span>
            </TableCell>
            <TableCell size="small" className={styles.scrapeErrorDateCell}>
              <span className={styles.scrapeErrorDate}>
                {checking(scrapeError?.ee_created_at).date}
              </span>
            </TableCell>
            <TableCell size="small" className={styles.stripeErrorReason}>
              <span className={styles.customtableCell}>
              {checking(scrapeError?.ee_created_at).time}
              </span>
            </TableCell>
          </StyledTableRow>
          );
        })}
      </TableBody>
      </>
    );
}

interface eventsRowType {
  e_id: string;
  e_name: string;
  e_date: string;
  e_address: string;
  e_status: string;
  e_time_zone: string;
  e_is_active: boolean;
}

export function EventsTableBody(props: any) {
  const { list, isSelected, handleClick, tableTitle, tablePurpose } = props;
  const { globalState, handleGlobalState } = useContext<any>(globalContext)
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const currentDate: any = Date.now();
  const {success,error} = ToasterWithMessage()

    const [updateEventState] = useMutation(UPDATE_ACTIVE_OR_INACTIVE_EVENT,{
    fetchPolicy: 'no-cache',
    onCompleted: (data) =>{
      success("Event updated successfully")
      const tempState = {...globalState};
      tempState.eventUpdate.updateEvent  = true
      handleGlobalState(tempState);
    },
    onError: () =>{
      error('Unable to update event')
    }
  })


  const handleUpdateEvent = (e_id: string, status: boolean) => {
    if(selectedRowId && e_id !== selectedRowId){
      error("Please select the event to update properly")
      return;
    }

    updateEventState({
      variables:{ 
          eId: e_id,
          setInput: {
            e_is_active: status,
            e_is_active_manual_override: !status
          }
      }
    })
  }
  
  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
        {list?.events?.map((row: eventsRowType, index: number) => {
          const isItemSelected = isSelected(index);
          const labelId = `enhanced-table-checkbox-${index}`;
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{ root: styles.rowStyle }}
            >
                 <TableCell
                      padding="checkbox"
                      classes={{
                        root: styles.tablecell,
                      }}
                      size="small"
                    >
                      <Checkbox
                        onClick={(event) => {
                          if(tableTitle === "pickEventsBulkList") {
                            handleClick(event, index, row?.e_id);
                          } else {
                            setSelectedIndex(index);
                            setSelectedRowId(row?.e_id);
                            handleClick(event, index, row?.e_id);
                          }
                        }}
                        classes={{
                          colorPrimary: styles.unselectCheckbox,
                          checked: styles.selectedCheckbox,
                        }}
                        disableRipple
                        checked={tableTitle === 'pickEventsBulkList' ? isItemSelected : isItemSelected && selectedIndex === index}
                        inputProps={{ 
                          "aria-labelledby": labelId,
                        }}
                      />
                    </TableCell>
              <TableCell size="small" className={styles.unsoldEventCell}>
                <div>{row?.e_name ? row?.e_name : '-'}</div>
              </TableCell>
              <TableCell size="small" className={styles.unsoldDateCell}>
                <div className={styles.unsolddateStyle}>
                    {(row?.e_date === null || row?.e_status === "date-tbd") ? (
                          <div className={styles.TbdForUnsold}>TBD</div>
                        ) : (
                          <>
                            <div>{checking(row?.e_date).date}</div>
                            <div>
                              {checking(row?.e_date).time}
                              <span className={styles.TbdForUnsold}>
                                {row?.e_status === 'time-tbd' ? "[ TBD ]" : ""}
                              </span>
                            </div>
                          </>
                   )}
                </div>
              </TableCell>
              <TableCell size="small" className={styles.unsoldVenueCell}>
                <div className={styles.unsoldvenueStyle}>
                  {
                    row?.e_address
                      ? <>
                        {splitLocationForVenue(row?.e_address)}
                      </>
                      : "-"
                  }

                </div>
              </TableCell>
              <TableCell size="small" className={styles.manageDateCell}>
                      <div className={styles.dateStyle}>
                        {(row?.e_date === null || row?.e_status === "date-tbd") ? (
                          <div className={styles.TbdForManage}>TBD</div>
                        ) : (
                          <>
                            <div>{checking(row?.e_date,row?.e_time_zone).date}</div>
                            <div>
                              {checking(row?.e_date,row?.e_time_zone).time}
                              <span className={styles.TbdForManage}>
                                {row?.e_status === 'time-tbd' ? "[ TBD ]" : ""}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </TableCell>
              <TableCell size="small" className={styles.managePeriodLeft}>
                      {(row?.e_date === null || row?.e_status === "date-tbd") ? ( "-" ) : getTimeRemaining(row?.e_date,currentDate) ? (
                        getTimeRemaining(row?.e_date,currentDate).includes("Hour" || "Hours" || "Minutes") ? (
                          <span className={styles.hourPeriodStyle}>
                            {`${getTimeRemaining(row?.e_date,currentDate)}`}
                          </span>
                        ) : (
                          <span className={styles.customtableCell}>
                            {`${getTimeRemaining(row?.e_date,currentDate)}`}
                          </span>
                        )
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    {
                      (tablePurpose === "eventsUpdate" || tablePurpose === "eventsOtherLeagues") &&
                      <TableCell
                      size="small"
                      className={styles.stickyTableCellForUser}
                      >
                        <div className={styles.buttonsWrapper}>
                            <div className={styles.inactivebtn}>
                              <Button classes={{root: styles.separateStyle}} sx={{color: '#22c55e'}} disabled={row?.e_is_active} fullWidth onClick={() => handleUpdateEvent(row?.e_id, true)}>Activate</Button>
                            </div>
                            <div className={styles.activebtn}>
                                <Button classes={{root: styles.separateStyle}} sx={{color: '#ef4444'}} disabled={!row?.e_is_active} fullWidth onClick={() => handleUpdateEvent(row?.e_id, false)}>Inactivate</Button>
                            </div>
                        </div>
                      </TableCell>
                    }
            </StyledTableRow>
          );
        })}
      </TableBody>
    </>
  );
}

export function AddTicketsManuallyErrorTableBody(props: any){
  const {
    list,
    isSelected
  } = props;

  return (
    <>
      <TableBody className={styles.addTicketErrorTablebodyStyle}>
        {list?.AddTicketByAdminLogs?.map((errorRow: any,index:number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{ root: styles.rowStyle }}
            >
              <TableCell size="small" className={styles.eventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.e_name ? errorRow?.e_name : "-"}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.eventDateCell}>
                  <span className={styles.customaddtableCell}>
                    {errorRow?.e_date ?  <span className={styles.customtableCell}>
                    <div className={styles.stripeErrorEventDateCell}>
                      <div>{checking(errorRow?.e_date).date}</div>
                      <div>{checking(errorRow?.e_date).time}</div>
                    </div>
                  </span> : <span> -</span>}
                  </span>
              </TableCell>
              <TableCell size="small" className={styles.addErrorAddressCell}>
                  <span className={styles.venueStyle}>
                    {errorRow?.e_address ? errorRow?.e_address : "-"}
                  </span>
                </TableCell>
                <TableCell size="small" className={styles.errorReasonCell}>
                  <span className={styles.errorReason}>
                    {errorRow?.message ? errorRow?.message : "-"}
                  </span>
                </TableCell>
              <TableCell size="small" className={styles.addErrorRaisedDate}>
                {errorRow?.created_at ? (
                  <span className={styles.customtableCell}>
                    <div className={styles.stripeErrorEventDateCell}>
                      <div>{checking(errorRow?.created_at).date}</div>
                      <div>{checking(errorRow?.created_at).time}</div>
                    </div>
                  </span>
                ) : (
                  <span> -</span>
                )}
              </TableCell>
              <TableCell size="small" className={styles.errorTicketPlacement}>
                <TicketPlacements
                  tickets={errorRow}
                  tableTitle={"manualTicketsError"}
                />
              </TableCell>
              <TableCell size="small" className={styles.errorUsersEmailCell}>
                  <span className={styles.customtableCell}>
                    {errorRow?.u_full_name ? errorRow?.u_full_name : '-'}
                  </span>
              </TableCell>
              <TableCell size="small" className={styles.errorUsersEmailCell}>
                  <span className={styles.customtableCell}>
                    {errorRow?.u_email_id ? errorRow?.u_email_id : '-'}
                  </span>
              </TableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </>
  );
}


export function VenuesTableBody(props: any) {
  const { list, isSelected, handleClick, tableTitle, tablePurpose,isSportsLeagueTable } = props;
  
  const { globalState, handleGlobalState } = useContext<any>(globalContext)
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const currentDate: any = Date.now();
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [venueToDelete, setVenueToDelete] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const [selectedVenue, setSelectedVenue] = useState<{ id: string; name: string; all_venue: Venue | null}>({
    id: "",
    name: "",
    all_venue: null
  });
  const { success, error } = ToasterWithMessage()

  const [updateVenueName] = useMutation(UPDATE_LEAGUE_TEAM_VENUE_AVID_BY_ID, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      success("Venue updated successfully")
      const tempState = { ...globalState };
      tempState.eventUpdate.updateEvent = true
      handleGlobalState(tempState);
    },
    onError: () => {
      error('Unable to update venue')
    }
  })
  const [deleteVenue] = useMutation(DELETE_VENUE_NAME_BY_ID, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      success("Venue deleted successfully")
      const tempState = { ...globalState };
      tempState.eventUpdate.updateEvent = true
      handleGlobalState(tempState);
    },
    onError: () => {
      error('Unable to delete venue')
    }
  })
  const handleUpdateEvent = (newVenueData: Venue) => {
    if (!selectedVenue.id) {
      error("No venue selected for update");
      return;
    }
    updateVenueName({
      variables: {
        ltv_id: selectedVenue.id,
        av_id: newVenueData.av_id
      },
    });
  };

  const handleDeleteEvent = (venueId: string, venueName: string) => {
    setVenueToDelete({ id: venueId, name: venueName });
    setOpenDelete(true);
  };

  const confirmDelete = () => {
    if (!venueToDelete.id) {
      error("No venue selected for deletion");
      return;
    }
    deleteVenue({
      variables: { ltv_id: venueToDelete.id },
    });
    setOpenDelete(false);
  };

  return (
    <>
      <TableBody className={styles.tablebodyStyle}>
        {list?.venues?.map((row: VenuesRowType, index: number) => {
          const isItemSelected = isSelected(index);
          const labelId = `enhanced-table-checkbox-${index}`;
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{ root: styles.rowStyle }}
            >
              <TableCell size="small" className={styles.unsoldEventCell}>
                <div>{row?.all_venue?.av_name || row?.ltv_name ||  '-'}</div>
              </TableCell>
              <TableCell size="small" className={styles.unsoldEventCell}>
                <div>{row?.all_venue?.av_venue_ref_id ||   '-'}</div>
              </TableCell>
              {
                (tablePurpose === "venuesUpdate") &&
                <TableCell
                  size="small"
                  className={styles.stickyTableCellForUser}
                >
                  <div className={styles.buttonsWrapperVenue}>
                    <div className={styles.inactivebtn}>
                      <Button
                        classes={{ root: styles.separateStyle }}
                        sx={{ color: "#5D75F8" }}
                        onClick={() => {
                          setSelectedVenue({id: row.ltv_id, name:row?.all_venue?.av_name || row.ltv_name, all_venue: row?.all_venue || null})
                          setOpenEdit(true);
                        }}
                      >
                        Edit
                      </Button>
                    </div>
                    <div className={styles.activebtn}>
                      <Button
                        classes={{ root: styles.separateStyle }}
                        sx={{ color: "#ef4444" }}
                        onClick={() => handleDeleteEvent(row?.ltv_id, row?.ltv_name)}
                        disabled = {isSportsLeagueTable ? (list?.venues?.length === 1):(list?.total_venues_of_league ===1)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </TableCell>
              }
            </StyledTableRow>
          );
        })}
      </TableBody>
      <EditVenueModal
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        onUpdate={handleUpdateEvent}
        initialVenue={selectedVenue}
      />
      <ConfirmDeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={confirmDelete}
        venueName={venueToDelete.name}
      />
    </>
  );
}


interface SuperUsersDataType{
  su_id:string
  u_id:string
  su_first_name:string
  su_last_name:string
  su_email_id:string
  percentage:number
  su_created_at:string
  su_deleted_at:string
  su_updated_at:string
}
export function SuperUsersTableBody(props :any){
    const {list, isSelected,refetchSuperUsersData,setSuperUsersList} = props;
    const [selectedRow,setSelectedRow]=useState<SuperUsersDataType | null>();
    const { success, error } = ToasterWithMessage()
    const [openDialogDeactivate, setOpenDialogDeactivate] = useState(false);
    const [openDialogEditPercentage,setOpenDialogEditPercentage]=useState(false);
    const {UserEdit} = images;
    const StyledComponent = CustomPaperComponent();

  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  

  console.log("Super User list in table body: ",list);
  
  const [deactivateSuperUser, { loading: deactivateSuperUserLoading }] = useMutation(DEACTIVATE_SUPER_USER, {
              fetchPolicy: "no-cache",
              onCompleted: (data) => {
                  success(data?.deactivateSuperUser?.message);
              },
              onError: (err) => {
                  console.log(err.message, "===error")
                  error(err?.message);
              }
  }); 

  const [EditPercentageForSuperUser, { loading: editPercentageForSuperUserLoading }] = useMutation(UPDATE_SUPER_USER_PERCENTAGE, {
              fetchPolicy: "no-cache",
              onCompleted: (data) => {
                  success("Percentage updated successfully");
              },
              onError: (err) => {
                  console.log(err.message, "===error")
                  error(err?.message);
              }
      }); 

  const handleEditUser = async(percentage:any) => {
    try {      
    const response = await EditPercentageForSuperUser({
      variables: {
        su_id: selectedRow?.su_id,
        percentage: parseFloat(percentage)
      }
    });
    if (response?.data?.update_super_user_by_pk) {
      const res=await refetchSuperUsersData();
      setSuperUsersList(res?.data)
      handleCloseDialogEditPercentage()
    } 
    
  } catch (err) {
    console.error("GraphQL Error:", err);
    handleCloseDialogEditPercentage()
    error("Error while updating percentage")
    
  }
  }
    const handleOpenDialogDeactivate = (row:SuperUsersDataType) =>{  
        setSelectedRow(row)   
        setOpenDialogDeactivate(true);
  }
   const handleOpenDialogEditPercentage = (row:SuperUsersDataType) =>{
        setSelectedRow(row)   
        setOpenDialogEditPercentage(true);
  }

  const handleCloseDialogDeactivate = () =>{
        setSelectedRow(null)
        setOpenDialogDeactivate(false)
  }
  const handleCloseDialogEditPercentage = () =>{
        setSelectedRow(null)   
        setOpenDialogEditPercentage(false);
  }


  const handleAllowDeactivate = async() => {
    await deactivateSuperUser({
      variables:{
          emailId:selectedRow?.su_email_id
      }
    });
    const res=await refetchSuperUsersData();
    setSuperUsersList(res?.data)
    handleCloseDialogDeactivate();
    setSelectedRow(null); 
  }

    return (
      <>
        <TableBody className={styles.tablebodyStyle}>
        {list?.super_user?.map((row: any, index: any) => {
          const isItemSelected = isSelected(index);
          const labelId = `enhanced-table-checkbox-${index}`;

          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{root: styles.rowStyle}}
            >
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.su_first_name} ${row?.su_last_name}`}</span></TableCell>
              <TableCell size="small" className={styles.usersUserNameCell}><span className={styles.customtableCell}>{`${row?.su_email_id}`}</span></TableCell>
              <TableCell size="small" className={styles.usersPhoneNumberCell}><span className={styles.customtableCell}>{`${row?.percentage}`}</span></TableCell>
       
              <TableCell size="small" className={styles.stickyTableCell}>
                    <div style={{display: 'flex',justifyContent:'space-evenly',width:'100%'}}>
                      <div className={styles.publishBtn}>
                        <Button
                          classes={{ root: styles.separateStyle }}
                          sx={{color: '#ef4444'}}
                          fullWidth
                          onClick={(e)=>handleOpenDialogDeactivate(row)}
                        >
                          Deactivate
                        </Button>
                      </div>
                      { (globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) &&
                      <div className={styles.editPriceBtn}>
                      <Button classes={{root: styles.editPriceSeparateStyle}} 
                      fullWidth onClick={() =>handleOpenDialogEditPercentage(row)} >
                        <img src={UserEdit} alt="useredit"/>
                      </Button>
                    </div>
                      }
                      </div>
                </TableCell>
            </StyledTableRow>
          );
        })}
        </TableBody>
        <Dialog
            open={openDialogDeactivate}
            PaperComponent={StyledComponent}
        >
              <PublishPopup title="Deactivate?" subTitle="Kindly confirm - Once you deactivated the user will be loss the super user access permanently" delist={true} handleAllow={handleAllowDeactivate} handleClose={handleCloseDialogDeactivate}/>
        </Dialog>
         <Dialog
            open={openDialogEditPercentage}
            PaperComponent={StyledComponent}
        >
            <NumberEditPopup
              title="Edit Super User"
              label="Percentage"
              defaultValue={selectedRow?.percentage}
              minValue={8}
              maxValue={20}   
              onSubmit={handleEditUser}
              onClose={handleCloseDialogEditPercentage}
            />
        </Dialog>

      </>
    );
}


export function AuditLogitixLogsTableBody(props: any){
  const {
    list,
    isSelected
  } = props;  
  return (
    <>
      <TableBody className={styles.addTicketErrorTablebodyStyle}>
        {list?.logitix_audit_logs?.map((errorRow: any,index:number) => {
          const isItemSelected = isSelected(index);
          return (
            <StyledTableRow
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={index}
              classes={{ root: styles.rowStyle }}
            >
               <TableCell size="small" className={styles.eventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.event?.e_name ? errorRow?.event?.e_name: "-"}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.usersUserNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.league?.l_name ? errorRow?.league?.l_name: "-"}
                </span>
              </TableCell>
               <TableCell size="small" className={styles.eventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.api_type ? errorRow?.api_type: "-"}
                </span>
              </TableCell>

               <TableCell size="small" className={styles.eventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.Action ? errorRow?.Action: "-"}
                </span>
              </TableCell>
              
              <TableCell size="small" className={styles.usersUserNameCell}>
                <span className={styles.customtableCell}
                style={{
                  color:
                    errorRow?.status.toUpperCase() === "SUCCESS"
                      ? "#22c55e"
                      :"#ef4444",
                  fontWeight: 600,
                }}>
                  {errorRow?.status ? errorRow?.status: "-"}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.errorTicketPlacement}>
                <TicketPlacements
                  tickets={errorRow}
                  tableTitle={"auditLogitixLogs"}
                />
              </TableCell>
              <TableCell size="small" className={styles.eventNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.venue ? errorRow?.venue: "-"}
                </span>
              </TableCell>
               <TableCell size="small" className={styles.listUserIdCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.old_listing_price ? formatNumberWithCommas(errorRow?.old_listing_price): "-"}
                </span>
              </TableCell>

               <TableCell size="small" className={styles.listUserIdCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.updated_listing_price ? formatNumberWithCommas(errorRow?.updated_listing_price): "-"}
                </span>
              </TableCell>
              <TableCell size="small" className={styles.usersUserNameCell}>
                <span className={styles.customtableCell}>
                  {errorRow?.user?.u_full_name ? errorRow?.user?.u_full_name: "-"}
                </span>
              </TableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </>
  );
}
